<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Material Chatbot</title>
    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.1.3/css/bootstrap.min.css">
    <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
    <link href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" rel="stylesheet">
    <!-- Google Fonts Link For Icons -->
    <link rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
    <link rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@48,400,1,0" />


    <link rel="stylesheet" type="text/css" href="style.css">

</head>



<template>

    <div class="chat-bot-icon" id="chatboxicon">
        <a href="javascript:void(0);"> <img src="Robot.jpg" id="toggleButton" alt="Bot Avatar" class="bot-icon"></a>
    </div>

    <div class="chat-container" hidden id="chatContainer" aria-label="Chatbot interaction">
        <div class="chat-header" id="chatHeader" aria-label="Chatbot Header">
            <img src="Robot.jpg" alt="Bot Avatar" class="bot-avatar"> 👋Hello Maya!! &nbsp;<span style="font-size: 11px;">Your virtual 🤖AI Assistant</span>
            <button class="toggle-button" id="toggleButtonn" aria-label="Minimize/Maximize chat">−</button>
        </div>
        <div id="chatMessages" class="chat-messages" aria-live="polite">
            <div class="typing-indicator" id="typingIndicator" aria-live="polite">
                <div class="dots">
                    <img src="http://barefootbeachbelize.kotina.com/Robot.jpg" alt="Bot Avatar" class="bot-avatar">
                    <span></span><span></span><span></span>
                </div>
            </div>
        </div>
        <div class="chat-input">
            <textarea id="userInput" type="text" placeholder="Type your message here..."
                      aria-label="User message"></textarea>
            <span id="sendButton" class="material-symbols-rounded">Send</span>
        </div>


        <div id="spinner" class="spinner" role="status" aria-label="Loading...">⏳</div>
        <div id="toast" class="toast-container"></div>
        <div id="overlay" onclick="closeToast()"></div>
        <div class="image-popup" id="imagePopup">
            <!-- <span class="close-btn" onclick="closeImagePopup()">×</span> -->
            <img id="popupImage" src="">
        </div>
        <input type="hidden" id="roomcap" value="">
        <div id="hiddenFieldsContainer"></div>
    </div>

</template>

<script setup>


    //pervent drag and drop and html tag input
    const textarea = document.getElementById('userInput');
    let bookCart = []; let assetId = null; let cartNameForDisplay = null;
    let tax = null;
    let insurance = null;
    let showIframe = false;
    let iframeUrl;
    let taxAmountTotal;
    let insuranceAmountTotal;
    let NetTotal;
    let basePrice;
    var data = localStorage.getItem('userinfo');
    if (data != null) {
        var userData = JSON.parse(data);
    }
    var userId = localStorage.getItem('userId');
    var companyId = localStorage.getItem('companyId');
    setTimeout(() => {
        if (textarea != null) {
            textarea.addEventListener('dragover', e => e.preventDefault());
            textarea.addEventListener('drop', e => e.preventDefault());
            textarea.addEventListener('input', () => {
                textarea.value = textarea.value.replace(/<\/?[^>]+(>|$)/g, "");
            });
        }
        else {

            showWelcomeMessage();
        }
        //right click disable
        // document.addEventListener('contextmenu', function (e) {
        //  e.preventDefault();
        //  });
        const API_ENDPOINT = "https://chatbot.talygen.com/query/";
        var username = getCookie("username");
        var token = getCookie("token");
        var sessionId = getCookie("session_id");
        if (!sessionId) {
            sessionId = generateSessionId();
            setCookie("session_id", sessionId, 1);
        }
        if (!username) {
            username = "Maya";
            setCookie("username", username, 1);
        }

        if (!token) {
            token = "abc123tokenvalue"; // You should get this from API on login
            setCookie("token", token, 1);
        }

        const textArea = document.getElementById('userInput');
        if (textArea != null) {
            textArea.addEventListener('focus', () => {
                textArea.selectionStart = textArea.selectionEnd = 0;
            });

        }
        window.resetCursorPosition = resetCursorPosition;
        function resetCursorPosition() {
            textArea.selectionStart = textArea.selectionEnd = 0;
        }
        window.showWelcomeMessage = showWelcomeMessage;
        document.addEventListener("DOMContentLoaded", () => {
            observeDOMChanges();  // Start observing for new "Book Now" buttons
            document.getElementById('sendButton').addEventListener('click', sendMessage);
            showWelcomeMessage();  // Display welcome message on load
        });

        function setCookie(name, value, days) {
            debugger
            const expires = new Date(Date.now() + days * 86400000).toUTCString();
            document.cookie = `${name}=${value}; expires=${expires}; path=/`;
        }

        // Cookie getter
        function getCookie(name) {
            debugger
            if (name == "username") {
                var data = localStorage.getItem('userinfo');
                var userData = JSON.parse(data);
                //const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                if (userData != null && userData != '') {
                    return userData.userName != null && userData.userName != undefined ? userData.userName : 'Maya';
                }
                else {
                    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                    return match ? match[2] : null;
                }
            }
            else {
                const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                return match ? match[2] : null;
            }

        }

        // Function to display the initial welcome message
        function showWelcomeMessage() {
            setTimeout(() => {
                const welcomeMessage = `
                    <strong class="wel-come">Welcome! </strong><br>
                    I am <strong>Maya</strong>, your virtual Assistant. <br>
                    How may I assist you today?
                `;
                addMessage(welcomeMessage, 'bot');
            }, Math.floor(Math.random() * 3000) + 1000); // Random delay between 1s to 2s
        }

        function generateSessionId() {
            return 'sess-' + Math.random().toString(36).substr(2, 9);
        }



        document.getElementById('sendButton').addEventListener('click', sendMessage);
        document.getElementById('userInput').addEventListener('keypress', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                sendMessage();
                resetCursorPosition();
            }
        });

        // Function to replace content between the specified markers
        function replaceContent(text) {
            return text.replace(/\[उदाहरण\] <>([\s\S]*?)<> \[\/Inst\]/g, '');
        }



        async function sendMessage() {
            debugger;
            const userInput = textArea.value.trim();
            textArea.value = '';
            //const userInput = document.getElementById('userInput').value.trim();
            const spinner = document.getElementById('spinner');
            const typingIndicator = document.getElementById('typingIndicator');
            if (userInput) {
                addMessage(userInput, 'user');

                spinner.style.display = 'inline-block';
                typingIndicator.style.display = 'block';
                var selected_lang = ""; //document.getElementById('languageSelect').value.trim();
                if (userId == null || userId == '') {
                    userId = null
                }
                try {
                    const dataModel = {
                        UserId: localStorage.getItem("userId"),
                        Sender: 'user',
                        Message: userInput,
                        UserName: username,
                        Session_Id: sessionId,
                        Intent: userInput,
                        CompanyId: localStorage.getItem("companyId")
                    }
                    await fetch(`https://stageapi.kotina.com/apigateway/GolfCart/SaveConversationHistory`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(dataModel),
                    })
                        .then(response => {
                            console.log("conversationresponse", response);
                        });
                }
                catch {

                }
                //debugger;
                fetch(API_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ user_query: userInput, session_id: sessionId, lang: selected_lang, token: token, username: username, userId: userId, companyId: companyId }),
                })
                    .then(response => response.json())
                    .then(data => {
                        debugger

                        displayBotResponseWithAnimation(data);

                    })
                    .catch(error => {
                        console.error('Error:', error);
                        addMessage('Error: ' + error.message, 'bot');
                    })
                    .finally(() => {
                        spinner.style.display = 'none';
                        typingIndicator.style.display = 'none';
                    });

                document.getElementById('userInput').value = '';
            } else {
                alert("Please enter a message.");
            }
        }

        function handleBookingClick(event) {
            debugger;
            const button = event.target;
            const attribute = button.getAttribute("data-attribute");
            const [room_type, hotel_id, room_id, hotel_name, price_per_night, tax, images] = attribute.split("^");
            debugger
            addMessage(`Want to book ${room_type} at ${hotel_name} at $${price_per_night}`, 'user');

            const chatMessages = document.getElementById("chatMessages");
            if (!chatMessages) {
                console.error("Element with id 'chatMessages' not found.");
                return;
            }

            let existingForm = document.getElementById("bookingFormContainer");
            if (existingForm) {

                chatMessages.scrollTop = chatMessages.scrollHeight;
                return;
            }

            const messageContainer = document.createElement("div");
            messageContainer.classList.add("message-container");
            messageContainer.id = "bookingFormContainer";

            const botAvatar = document.createElement('img');
            botAvatar.src = 'Robot.jpg';
            botAvatar.alt = 'Bot Avatar';
            botAvatar.classList.add('bot-avatar');
            messageContainer.appendChild(botAvatar);

            const messageDiv = document.createElement("div");
            messageDiv.classList.add("message", "bot", "form-group");

            const CalculateTax = (parseFloat(price_per_night) * parseFloat(tax) / 100).toFixed(2);



            messageDiv.innerHTML = `
                    <div class="booking-card">
                    <div class="booking-card-header">
                    <h3>Booking Details</h3>
                    <p>Please fill in your details:</p>
                    </div>
                    <div class="hidden-inputs">
                    <input type="hidden" id="originaltax" value="${tax}">
                    <input type="hidden" id="bookingimage" value="${images}">
                    <input type="hidden" id="hotelId" value="${hotel_id}">
                    <input type="hidden" id="roomId" value="${room_id}">
                    <input type="hidden" id="hotel_name" value="${hotel_name}">
                    <input type="hidden" id="roomtype" value="${room_type}">
                    <input type="hidden" id="price_per_night" value="${price_per_night}">

                    </div>
                    <div class="booking-card-body">
                    <div class="form-row">
                    <label>Hotel:</label>
                    <strong>${hotel_name}</strong>
                    </div>
                    <div class="form-row">
                    <label>Room Type:</label>
                    <strong>${room_type}</strong>
                    </div>
                    <div class="form-row">
                    <label for="name">Name:</label>
                    <input type="text" id="name" placeholder="Enter your name" required>
                    </div>
                    <div class="form-row">
                    <label for="phone">Phone:</label>
                    <input type="tel" id="phone" placeholder="Enter your phone" required pattern="[0-9]{1,14}"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 14);">
                    </div>
                    <div class="form-row">
                    <label for="email">Email:</label>
                    <input type="email" id="email" placeholder="Enter your email" required>
                    <span id="emailError" style="color: red; display: none;">Please enter a valid email address.</span>

                    </div>
                    <div class="form-row">
                    <label for="checkinDate">Check-in Date:</label>
                    <input type="date" id="checkinDate" required onchange="updateTotalPrice()">
                    </div>
                    <div class="form-row">
                    <label for="checkoutDate">Check-out Date:</label>
                    <input type="date" id="checkoutDate" required onchange="updateTotalPrice()">
                    </div>
                    <div class="form-row">
                    <label for="specialrequest">Special Request:</label>
                    <input type="text" id="specialrequest" placeholder="Enter any special request">
                    </div>
                    <div class="form-row">
                    <label for="numRooms">Number of Rooms:</label>
                    <select id="numRooms" onchange="updateTotalPrice()">
                    <option value="1">1 Room</option>
                    <option value="2">2 Rooms</option>
                    <option value="3">3 Rooms</option>
                    <option value="4">4 Rooms</option>
                    </select>
                    </div>
                    <div class="form-row">
                    <label for="adults">Adults:</label>
                    <select id="adults" onchange="updateTotalPrice()">
                    <option value="0" selected>No Adult</option>
                    <option value="1">1 Adult</option>
                    <option value="2">2 Adults</option>
                    <option value="3">3 Adults</option>
                    <option value="4">4 Adults</option>
                    </select>
                    </div>
                    <div class="form-row">
                    <label for="children">Children (0-17 Years):</label>
                    <select id="children" onchange="childdrpdwn()">
                    <option value="0" selected>No Children</option>
                    <option value="1">1 Child</option>
                    <option value="2">2 Children</option>
                    <option value="3">3 Children</option>
                    </select>
                    <p class="note">Please provide children's age for better options.</p>
                    </div>
                    <div class="form-row">
                    <label>Taxes: ${tax}%</label>
                    <strong id="calculatedtax">$${CalculateTax}</strong>

                    </div>
                    <div class="form-row">
                    <label>Total Price:</label>
                    <strong id="totalPrice">$0.00</strong>
                    </div>
                    <div class="form-row">
                    <label>Net Total Price:</label>
                    <strong id="NettotalPrice">$0.00</strong>

                    </div>
                    </div>
                    <div class="booking-card-footer">
                    <button id="confirmBookingBtn" onclick="confirmBooking()">Confirm Booking</button>
                    </div>
                    </div>`;

            messageContainer.appendChild(messageDiv);
            var isDisabled = false;
            debugger
            let oldForm = document.getElementById("bookingFormContainer");
            if (oldForm) {
                chatMessages.removeChild(oldForm);
            }
            chatMessages.appendChild(messageContainer);
            chatMessages.scrollTop = chatMessages.scrollHeight;
            let checkinInput = document.getElementById("checkinDate");
            let checkoutInput = document.getElementById("checkoutDate");
            let today = new Date().toISOString().split("T")[0];
            checkinInput.setAttribute("min", today);
            // Optional: Validate on input change
            document.getElementById("email").addEventListener("input", validateEmail);

            checkinInput.addEventListener("change", function () {
                debugger
                let checkinDate = new Date(this.value);
                if (checkoutInput.value) {
                    let checkoutDate = new Date(checkoutInput.value);
                    if (checkoutDate <= checkinDate) {
                        alert("Check-out date must be later than check-in date.");
                        checkoutInput.value = "";


                    }
                }
                checkoutInput.setAttribute("min", this.value);
            });

            document.getElementById("numRooms").addEventListener("change", function () {
                debugger
                const button = document.getElementById('confirmBookingBtn');
                const capacity = parseInt(document.getElementById("roomcap").value);
                if (capacity) {
                    const numRooms = parseInt(this.value);
                    const roomCapacity = parseInt(document.getElementById("roomcap").value) || 0;
                    const totalCapacity = numRooms * roomCapacity;

                    const adults = parseInt(document.getElementById('adults').value);   // Convert to number
                    const children = parseInt(document.getElementById('children').value); // Convert to number
                    var total = adults + children;
                    if (total > totalCapacity) {
                        button.disabled = true;
                        button.style.backgroundColor = "red";
                        showToast(`✅ only  ${capacity} people can stay in this room select room according the number of people will stay`);
                    }
                    else {
                        button.disabled = false;
                        button.style.backgroundColor = "#28a745";
                    }
                    let childrenDropdown = document.getElementById("children");
                    childrenDropdown.selectedIndex = 0;
                    let adltDropdown = document.getElementById("adults");
                    adltDropdown.selectedIndex = 1;
                }

            });

            document.getElementById("adults").addEventListener("change", function () {
                debugger
                const button = document.getElementById('confirmBookingBtn');
                const capacity = parseInt(document.getElementById("roomcap").value);
                const adults = parseInt(document.getElementById('adults').value);
                const numbrofroom = parseInt(document.getElementById('numRooms').value);
                const roomCapacity = parseInt(document.getElementById("roomcap").value) || 0;
                const totalCapacity = numbrofroom * roomCapacity;
                if (capacity) {
                    if (adults > totalCapacity) {
                        button.disabled = true;
                        button.style.backgroundColor = "red";
                        showToast(`✅ only  ${capacity} people can stay in this room select room according the number of people will stay`);
                    }
                    else {
                        button.disabled = false;
                        button.style.backgroundColor = "#28a745";
                    }
                }
                let childrenDropdown = document.getElementById("children");
                childrenDropdown.selectedIndex = 0; // Reset to "No Children"
            });

            checkoutInput.addEventListener("change", function () {
                let adultsDropdown = document.getElementById("adults");
                adultsDropdown.selectedIndex = 1;
                let checkinDate = new Date(checkinInput.value);
                let checkoutDate = new Date(this.value);
                if (checkoutDate <= checkinDate) {
                    alert("Check-out date must be later than check-in date.");
                    this.value = "";
                }
                const hotelId = document.getElementById('hotelId').value;
                const roomId = document.getElementById('roomId').value;
                const roomdetail = {
                    checkinDate: new Date(checkinDate).toISOString().split('T')[0],
                    checkoutDate: new Date(checkoutDate).toISOString().split('T')[0],
                    hotelId,
                    roomId
                };
                if (checkoutDate > checkinDate) {
                    sendRoomInquiry(roomdetail);
                    debugger
                    let childrenDropdown = document.getElementById("children");
                    let roomDropdown = document.getElementById("numRooms");
                    let adltDropdown = document.getElementById("adults");

                    adltDropdown.selectedIndex = 0;
                    childrenDropdown.selectedIndex = 0;
                    roomDropdown.selectedIndex = 0;
                }
            });
        }

        function validateEmail() {
            const emailInput = document.getElementById("email");
            const emailError = document.getElementById("emailError");

            // Get email value
            const email = emailInput.value.trim();

            // Email regex pattern
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            // Check if email is valid
            if (emailPattern.test(email)) {
                emailError.style.display = "none"; // Hide error if valid
                return true;
            } else {
                emailError.style.display = "block"; // Show error if invalid
                return false;
            }
        }


        function childdrpdwn() {
            debugger;
            const button = document.getElementById('confirmBookingBtn');
            const capacity = parseInt(document.getElementById("roomcap").value); // Parse capacity to number
            const adults = parseInt(document.getElementById('adults').value);    // Convert to number
            const children = parseInt(document.getElementById('children').value); // Convert to number
            const numbrofroomchild = parseInt(document.getElementById('numRooms').value); // Number of rooms selected
            const totalCapacity1 = capacity * numbrofroomchild; // Total capacity based on selected rooms

            const total = adults + children;
            console.log(total);

            if (capacity) {
                if (total > totalCapacity1) {
                    button.disabled = true;
                    button.style.backgroundColor = "red";
                    showToast(`✅ Only ${totalCapacity1} people can stay in this room. Please adjust the number of rooms.`);
                } else {
                    button.disabled = false;
                    button.style.backgroundColor = "#28a745";
                }
            }
        }

        function showToast(message) {
            const toast = document.getElementById("toast");
            const overlay = document.getElementById("overlay");

            toast.innerHTML = `
                    <span class="toast-message">${message}</span>
                    <span class="close-btn" onclick="closeToast()">×</span>
                    `;

            // Show toast and overlay
            toast.className = "show";
            overlay.style.display = "block";
        }

        function closeToast() {
            const toast = document.getElementById("toast");
            const overlay = document.getElementById("overlay");

            // Hide toast and overlay
            toast.className = "";
            overlay.style.display = "none";
        }

        async function sendRoomInquiry(roomDetails) {

            debugger
            console.log("Sending data:", roomDetails);


            try {
                const response = await fetch("https://chatbot.talygen.com/roomInque/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(roomDetails)
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                // Parse the response
                const result = await response.json();
                debugger;
                console.log("Response:", result);
                debugger;
                const remainingCapacity = result.available_rooms[0].capacity || "N/A";
                document.getElementById("roomcap").value = remainingCapacity;


            } catch (error) {
                showToast("Room is not Available on this date!");
                console.error("Error:", error);

            }

        }


        function updateTotalPrice() {
            const numRooms = parseInt(document.getElementById("numRooms").value);
            const pricePerNight = parseFloat(document.getElementById("price_per_night").value);
            const checkinDate = document.getElementById('checkinDate').value;
            const checkoutDate = document.getElementById('checkoutDate').value;
            const tax = parseFloat(document.getElementById('originaltax').value);

            // Check if dates are valid
            const checkin = new Date(checkinDate);
            const checkout = new Date(checkoutDate);

            const timeDifference = checkout - checkin;
            let daysDifference = timeDifference / (1000 * 60 * 60 * 24);

            if (isNaN(daysDifference) || daysDifference <= 0) {
                daysDifference = 1;
            }

            // Calculate total price
            const totalPrice = numRooms * pricePerNight * daysDifference;

            // Calculate tax
            const updatedtaxes = (totalPrice * tax / 100).toFixed(2);

            // Net total price with taxes
            const netTotal = (totalPrice + parseFloat(updatedtaxes)).toFixed(2);

            // Update UI
            document.getElementById("totalPrice").innerText = `$${totalPrice.toFixed(2)}`;
            document.getElementById("calculatedtax").innerText = `$${updatedtaxes}`;
            document.getElementById("NettotalPrice").innerText = `$${netTotal}`;
        }

        function addBookNowEventListeners() {

            const bookNowButtons = document.querySelectorAll(".btn-book");
            bookNowButtons.forEach(button => {
                button.addEventListener("click", handleBookingClick);
            });
        }

        function displayBookingForm() {
            const dynamicContent = document.getElementById('dynamic-content');

            // Attach event listener to the confirm button for capturing form data
            document.getElementById('confirmBooking').addEventListener('click', () => confirmBooking(hotelName, roomName));
        }

        function confirmBooking() {

            const image = document.getElementById('bookingimage').value;
            const gettax = parseFloat(document.getElementById('calculatedtax').innerText.replace('$', '')); // Corrected
            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            const phone = document.getElementById('phone').value;
            const checkinDate = document.getElementById('checkinDate').value;
            const checkoutDate = document.getElementById('checkoutDate').value;
            const hotelName = document.getElementById('hotel_name').value;
            const roomType = document.getElementById('roomtype').value;
            const pricePerNight = document.getElementById('price_per_night').value;
            const hotelId = document.getElementById('hotelId').value;
            const roomId = document.getElementById('roomId').value;
            const adults = parseInt(document.getElementById('adults').value);
            const children = document.getElementById('children').value;
            const specialRequest = document.getElementById('specialrequest').value;
            const NettotalPrice = parseFloat(document.getElementById('NettotalPrice').innerText.replace('$', ''));
            const totalPrice = parseFloat(document.getElementById('totalPrice').innerText.replace('$', ''));

            // Validate that all fields are filled
            if (!name || !adults || !email || !phone || !checkinDate || !checkoutDate) {
                alert("Please fill in all fields to confirm your booking.");
                return;
            }


            // Create the booking payload
            const bookingPayload = {
                hotelName,
                roomType,
                pricePerNight,
                name,
                email,
                phone,
                checkinDate,
                checkoutDate,
                hotelId,
                roomId,
                totalPrice,
                adults,
                children,
                specialRequest,
                NettotalPrice,
                gettax
            };


            let formattedText = `Booking confirmed for Hotel:- <span class="hidden-text">${hotelName}, Room-Type:-${roomType},
        for Name:-${name}, Email:-${email},- Phone:-${phone}, Check-in-Date:-${checkinDate}, Check-out-Date:-${checkoutDate},
        TotalPrice:-${totalPrice}, Taxes:-${gettax}, NetTotalPrice:-${NettotalPrice}, Adults:-${adults},
        Kids:-${children}, Room-no:-${roomId}, Hotel-ID:-${hotelId},Request:-${specialRequest},Image:-${image} </span>`;

            $("#userInput").val(formattedText);
            sendMessage();
        }


        document.addEventListener("click", function (event) {
            if (event.target.classList.contains("btn-book")) {
                const chatMessages = document.getElementById("chatMessages");
                if (chatMessages) {
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
            }
        });

        // Call addBookNowEventListeners whenever new buttons are added to the DOM
        function observeDOMChanges() {
            const chatMessages = document.getElementById('chatMessages');
            const observer = new MutationObserver(() =>
                addBookNowEventListeners());
            observer.observe(chatMessages, { childList: true, subtree: true });
        }

        document.addEventListener("DOMContentLoaded", () => {
            observeDOMChanges();  // Start observing for new "Book Now" buttons
            document.getElementById('sendButton').addEventListener('click', sendMessage);
        });

        function addMessage(message, sender) {
            const chatMessages = document.getElementById('chatMessages');
            const messageContainer = document.createElement('div');
            messageContainer.classList.add('message-container');
            if (sender == 'bot') {
                messageContainer.classList.add('botClass');
            }
            else if (sender == 'user') {
                messageContainer.classList.add('userClass');
            }
            const messageDiv = document.createElement('div');
            messageDiv.classList.add('message', sender);
            messageDiv.innerHTML = message;

            if (sender === 'bot') {
                const botAvatar = document.createElement('img');
                botAvatar.src = 'Robot.jpg';
                botAvatar.alt = 'Bot Avatar';
                botAvatar.classList.add('bot-avatar');
                messageContainer.appendChild(botAvatar);
            }

            messageContainer.appendChild(messageDiv);
            chatMessages.appendChild(messageContainer);
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }

        const chatContainer = document.getElementById('chatContainer');
        const toggleButton = document.getElementById('toggleButton');
        const chatboxicon = document.getElementById('chatboxicon');
        const toggleButtonn = document.getElementById('toggleButtonn');
        const chatHeader = document.getElementById('chatHeader');

        chatContainer.hidden = true;

        toggleButton.addEventListener('click', () => {
            chatContainer.hidden = false;
            chatboxicon.hidden = true;
            chatContainer.classList.add('open');
            chatHeader.style.display = "block";
        });

        toggleButtonn.addEventListener('click', () => {
            const isOpen = chatContainer.classList.contains('open');
            chatboxicon.hidden = false;
            if (isOpen) {
                chatContainer.classList.remove('open');
                chatboxicon.hidden = false;
                chatContainer.hidden = true;
                chatHeader.style.display = "none";
            } else {
                chatboxicon.hidden = true;
                chatContainer.hidden = false;
                chatContainer.classList.add('open');
                chatHeader.style.display = "block";
            }
        });
        setTimeout(() => {
            chatContainer.hidden = false;
            chatContainer.classList.add('open');
        }, 3000);



        function appendUserMessage(userMessage, chatMessages) {
            // Create user message container
            const messageContainer = document.createElement("div");
            messageContainer.classList.add("message-container", "user-message");

            // User message wrapper
            const userMessageDiv = document.createElement("div");
            userMessageDiv.classList.add("message", "user");
            userMessageDiv.textContent = userMessage.message;

            messageContainer.appendChild(userMessageDiv);
            chatMessages.appendChild(messageContainer);
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }
        // Function to send selected hotel ID
        function sendHotelSelection(hotelId, hotelName) {
            const userMessage = { type: "user", message: `Selected Hotel:${hotelName}` };
            //appendUserMessage(userMessage, chatMessages);

            // Send the hotelId back to your backend or chat system
            //sendMessageToBackend({ Intent: "hotel_selected", hotel_id: hotelId });
            let formattedText = `Selected Hotel:-${hotelName} <span class="hidden-text">${hotelName}, HotelId:-${hotelId}</span>`;
            $("#userInput").val(formattedText);
            sendMessage();
        }

        //✅ Supporting JavaScript for Hotel Menu

        // Function to show image popup inside the chat window with a dark background
        function showImagePopup(imgSrc, dishName, nutritionInfo, dietInfo) {
            debugger;

            // Decode data from URI format
            imgSrc = decodeURIComponent(imgSrc);
            dishName = decodeURIComponent(dishName);
            dietInfo = decodeURIComponent(dietInfo);

            try {
                nutritionInfo = JSON.parse(decodeURIComponent(nutritionInfo));
            } catch (e) {
                console.error("Invalid nutrition JSON", e);
                nutritionInfo = {}; // Fallback if parsing fails
            }

            // Get the chat container
            const chatWindow = document.getElementById("chatMessages"); // Ensure this ID exists in your HTML

            if (!chatWindow) {
                console.error("Chat window container not found!");
                return;
            }

            // Remove existing popup if already open
            const existingPopup = document.getElementById("chatPopupOverlay");
            if (existingPopup) {
                existingPopup.remove();
            }

            // Create a dark overlay inside the chat window to disable scrolling and highlight popup
            const darkOverlay = document.createElement("div");
            darkOverlay.id = "chatPopupBackground";
            darkOverlay.style.cssText = `
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            background: rgba(0, 0, 0, 0.7);
            backdrop-filter: blur(3px);
            z-index: 998;
        `;

            // Disable scrolling while the popup is open
            chatWindow.style.overflow = "hidden";

            // Create popup container
            const popup = document.createElement("div");
            popup.id = "chatPopupOverlay";
            popup.style.cssText = `
            position: absolute;
            bottom: 10px; left: 50%; transform: translateX(-50%);
            width: 90%; max-width: 350px;
            background: white; padding: 15px; border-radius: 10px;
            box-shadow: 0 4px 8px rgba(0,0,0,0.3); text-align: center;
            z-index: 999;
        `;

            // Create nutrition table HTML
            let nutritionTable = `
            <h3 style="margin-top: 5px; font-size: 14px;">Nutritional Facts</h3>
            <table style="width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 5px;">
                <tr><th style="padding: 4px; border: 1px solid #ddd;">Nutrient</th>
                    <th style="padding: 4px; border: 1px solid #ddd;">Value</th></tr>`;

            Object.entries(nutritionInfo).forEach(([key, value]) => {
                nutritionTable += `<tr>
                <td style="padding: 4px; border: 1px solid #ddd;">${key}</td>
                <td style="padding: 4px; border: 1px solid #ddd;">${value}</td>
            </tr>`;
            });

            nutritionTable += `</table>`;

            // Set popup content
            popup.innerHTML = `
            <h4 style="margin-bottom: 5px;">${dishName}</h4>
            <img src="${imgSrc}" style="width: 100%; max-height: 200px; object-fit: contain; border-radius: 5px;">
            <p style="margin-top: 5px; font-size: 12px; text-align: left;">${dietInfo}</p>
            ${nutritionTable}
            <button class="btn-clear" onclick="closeChatPopup()"
                style="margin-top: 8px; padding: 5px 10px; background: #ff4757; color: white;
                border: none; cursor: pointer; border-radius: 5px; font-size: 12px;">
                Close
            </button>`;

            // Append popup and dark overlay to the chat window
            chatWindow.appendChild(darkOverlay);
            chatWindow.appendChild(popup);
        }

        // Function to close popup and remove the dark background
        function closeChatPopup() {
            const chatWindow = document.getElementById("chatMessages");
            const popup = document.getElementById("chatPopupOverlay");
            const darkOverlay = document.getElementById("chatPopupBackground");

            if (popup) popup.remove();
            if (darkOverlay) darkOverlay.remove();

            // Re-enable scrolling after popup is closed
            chatWindow.style.overflow = "auto";
        }






        // Function to calculate total price
        function calculateTotal() {
            let totalPrice = 0, taxRate = 0.1, discountRate = 0.05;

            document.querySelectorAll(".dish-checkbox").forEach((checkbox, index) => {
                if (checkbox.checked) {
                    let price = parseFloat(checkbox.getAttribute("data-price"));
                    let quantity = parseInt(document.querySelectorAll(".qty-input")[index].value) || 1;
                    totalPrice += price * quantity;
                }
            });

            let taxAmount = totalPrice * taxRate;
            let discountAmount = totalPrice > 50 ? totalPrice * discountRate : 0;
            let finalTotal = totalPrice + taxAmount - discountAmount;

            document.getElementById("total-price").innerText = totalPrice.toFixed(2);
            document.getElementById("tax-amount").innerText = taxAmount.toFixed(2);
            document.getElementById("discount-amount").innerText = discountAmount.toFixed(2);
            document.getElementById("final-total").innerText = finalTotal.toFixed(2);
        }

        // Function to clear order selection
        function clearOrder() {
            document.querySelectorAll(".dish-checkbox").forEach(checkbox => checkbox.checked = false);
            document.querySelectorAll(".qty-input").forEach(input => input.value = 1);
            calculateTotal();
        }

        // Function to process order booking
        function bookOrder() {
            let selectedDishes = [];
            document.querySelectorAll(".dish-checkbox").forEach((checkbox, index) => {
                if (checkbox.checked) {
                    let row = checkbox.closest("tr");
                    selectedDishes.push({
                        dish: row.cells[2].innerText,
                        price: parseFloat(checkbox.getAttribute("data-price")),
                        quantity: parseInt(document.querySelectorAll(".qty-input")[index].value)
                    });
                }
            });

            if (selectedDishes.length === 0) {
                alert("Please select at least one dish to book your order.");
                return;
            }

            alert("Order placed successfully!");
        }
        window.bookCart = bookCart;
        //window.resetCursorPosition = resetCursorPosition;
        async function bookCart(button) {
            debugger;
            insurance = button.insurance;
            tax = button.tax;
            assetId = button.id;
            cartNameForDisplay = button.name;
            loadCartPrices(button.id)
            const chatMessages = document.getElementById("chatMessages");
            if (!chatMessages) {
                console.error("Element with id 'chatMessages' not found.");
                return;
            }
            addMessage(`Want to book ${button.name} at Mahogany Bay Resort at $${button.price}`, 'user');
            let existingForm = document.getElementById("bookingFormContainer");
            if (existingForm) {
                existingForm.remove();
            }
            const messageContainer = document.createElement("div");
            messageContainer.classList.add("message-container");
            messageContainer.id = "bookingFormContainer";
            const botAvatar = document.createElement('img');
            botAvatar.src = 'Robot.jpg';
            botAvatar.alt = 'Bot Avatar';
            botAvatar.classList.add('bot-avatar');
            messageContainer.appendChild(botAvatar);
            const cartName = button.cart_name || "N/A";
            const cartType = button.cart_type || "N/A";
            const description = button.description || "";
            const cartId = button.cart_id || "N/A";
            const Id = button.id || "N/A";
            const rentalType = button.rental_type || "hourly";
            const deliveryLocation = "Mahogany Bay Resort & Beach Club, Sea  Grape Drive, San Pedro, Belize";
            const returnLocation = "Mahogany Bay Resort & Beach Club, Sea  Grape Drive, San Pedro, Belize";
            const messageDiv = document.createElement("div");
            messageDiv.classList.add("message", "bot", "form-group");
            messageDiv.innerHTML = `
            <div class="booking-card">
                <div class="booking-card-header">

                    <h3>Booking Information</h3>
                  <div class="py-1"><strong class="text-white">Cart Name:</strong> ${button.name || "Not specified"}</div>
                    <p>Please fill in your details:</p>
                </div>
                <div class="booking-card-body">
                    <div class="form-row labeled-row">
                       <label for="priceDropdown">Select Rental Duration:</label>
                       <select id="priceDropdown" onchange="onPriceChange()">
                       <option value="">-- Select --</option>
                       </select>
                    </div>
                       <div  class="form-row labeled-row price">
                       <label>Price ($):</label>
                       <span id="selectedPrice">$0.00</span>
                    </div>
                    <div  class="form-row labeled-row price">
                    <label>Tax ($):</label>
                    <span id="selectedPriceTaxAmount">$0.00</span>
                    </div>
                    <div  class="form-row labeled-row price">
                    <label>Insurance ($):</label>
                    <span id="selectedPriceInsuranceAmount">$0.00</span>
                    </div>
                    <div  class="form-row labeled-row price">
                    <label>Total Amount ($):</label>
                    <span id="selectedPriceTotalAmount">$0.00</span>
                    </div>
                    <div  class="form-row labeled-row delivery-loc ">
                        <label>Delivery Location:</label>
                        <strong style="">${deliveryLocation}</strong>
                    </div>

                    <div  class="form-row labeled-row delivery-loc">
                        <label>Return Location:</label>
                        <strong style="">${returnLocation}</strong>
                    </div>

                    <div class="form-row labeled-row">
                    <label for="pickupDate">Pickup Date:<span class="text-danger">*</span></label>
                    <input type="date" id="pickupDate" onchange="updatereturndate()" >

                    </div>
                     <span id="pickupDateError" class="error-msg" style="display:none;"></span>
                    <div  class="form-row labeled-row">
                    <label for="pickupTime" >Pickup Time:<span class="text-danger">*</span></label>
                    <select id="pickupTime" onchange="updatereturntime()" >
                    <option value="">-- Select Time --</option>
                    ${[...Array(13 * 4)].map((_, i) => {
                const hours = 7 + Math.floor(i / 4);
                const minutes = (i % 4) * 15;
                const time = new Date();
                time.setHours(hours, minutes);
                const options = { hour: 'numeric', minute: '2-digit' };
                return `<option value="${time.toLocaleTimeString([], options)}">${time.toLocaleTimeString([], options)}</option>`;
            }).join('')}
                        </select>

                    </div>
                     <span id="pickupTimeError" class="error-msg" style="display:none;"></span>

                    <div  class="form-row labeled-row">
                        <label for="returnDate">Return Date:<span class="text-danger">*</span></label>
                        <input   type="date" id="returnDate" disabled>

                    </div>
                   <!--  <span id="returnDateError" class="error-msg" style="display:none;"></span> -->
                     <div  class="form-row labeled-row">
                        <label for="returnTime">Return Time:<span class="text-danger">*</span></label>
                        <select id="returnTime" disabled>
                              <option value="">-- Select Time --</option>
                              ${[...Array(((24 - 7) * 4) + 1)].map((_, i) => {
                const hours = 7 + Math.floor(i / 4);
                const minutes = (i % 4) * 15;

                const time = new Date();
                time.setHours(hours, minutes, 0, 0);

                const options = { hour: 'numeric', minute: '2-digit' };
                return `<option value="${time.toLocaleTimeString([], options)}">${time.toLocaleTimeString([], options)}</option>`;
            }).join('')}
                        </select>

                    </div>
                   <!--  <span id="returnTimeError" class="error-msg" style="display:none;"></span> -->
                    <div  class="form-row labeled-row">
                        <label for="username">Name:<span class="text-danger">*</span></label>
                        <input type="text" id="username" placeholder="Enter your name" required>

                    </div>
                     <span id="usernameError" class="error-msg" style="display:none;"></span>
                    <div class="form-row">
                        <label for="userphone">Phone:<span class="text-danger">*</span></label>
                        <input type="tel" id="userphone" placeholder="Enter your phone" required pattern="[0-9]{1,14}" oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 14);">

                    </div>
                     <span id="userphoneError" class="error-msg" style="display:none;"></span>
                    <div class="form-row">
                        <label for="useremail">Email:<span class="text-danger">*</span></label>
                        <input type="email" id="useremail" placeholder="Enter your email" required>

                        <span id="emailError" style="color: red; display: none;">Please enter a valid email address.</span>
                    </div>
                     <span id="useremailError" class="error-msg" style="display:none;"></span>
                    <div class="form-row">
                        <label for="userAddress">Address:</label>
                        <input type="text" id="userAddress" placeholder="Enter your address" required>
                    </div>
                    <div class="form-row check-box">
                        <input type="checkbox" id="deliverKey" checked>
                        <label for="deliverKey">Deliver cart keys to the room?</label>
                    </div>
                    <div class="form-row">
                        <label for="roomNumber">Room Number (If alloted):</label>
                        <input type="text" id="roomNumber" placeholder="Enter room number" required>
                    </div>
                    <div class="form-row" style="text-align:right; margin-top: 10px;margin-bottom:10px">
                        <button class="btn-book" onclick="submitBooking(this,'${cartName}', '${cartId}', '${cartType}', '${description}', '${deliveryLocation}',
            '${returnLocation}','${taxAmountTotal}','${insuranceAmountTotal}','${basePrice}','${NetTotal}')" class="btn btn-primary">Submit Booking</button>
                    </div>
                </div>
            </div>
        `;

            messageContainer.appendChild(messageDiv);
            chatMessages.appendChild(messageContainer);
            chatMessages.scrollTop = chatMessages.scrollHeight;

            let checkinInput = document.getElementById("pickupDate");
            let today = new Date().toISOString().split("T")[0];
            checkinInput.setAttribute("min", today);

            const message = {
                Intent: "Book_Cart",
                cart_id: cartId,
                cart_name: cartName,
                rental_type: rentalType,
                requested_at: new Date().toISOString()
            };
            var userAddress;
            if (userData != null && userData != '') {
                userAddress = userData.address + ', ' + userData.city + ', ' + userData.stateName + ', ' + userData.countryName + ', ' + userData.zipCode
                console.log('userAddress', userAddress);
                document.getElementById("userAddress").value = userAddress;
                document.getElementById("username").value = userData.firstName + '' + userData.lastName;
                document.getElementById("userphone").value = userData.phoneNumber;
                document.getElementById("useremail").value = userData.email;
            }
            else {
                document.getElementById("userAddress").value = '';
            }
        }
        window.onPriceChange = onPriceChange;
        function onPriceChange() {
            document.getElementById("pickupDate").value = "";
            document.getElementById("pickupTime").selectedIndex = 0;
            document.getElementById("returnDate").value = "";
            document.getElementById("returnTime").selectedIndex = 0;
        }

        function updatereturntime() {
            debugger
            const selectedOption = document.getElementById("priceDropdown")?.options[
                document.getElementById("priceDropdown").selectedIndex
            ];
            const duration = parseInt(selectedOption?.getAttribute("value"));

            const pickupTimeSelect = document.getElementById("pickupTime");
            const returnTimeSelect = document.getElementById("returnTime");

            if (!pickupTimeSelect || !returnTimeSelect || isNaN(duration)) {
                console.error("Missing elements or invalid duration.");
                return;
            }

            const pickupTimeStr = pickupTimeSelect.value;
            const [pickupHour, pickupMinute] = pickupTimeStr.split(/[: ]/); // handles "7:15 AM" etc.
            const isPM = pickupTimeStr.includes("PM");

            let hours = parseInt(pickupHour);
            if (isPM && hours < 12) hours += 12;
            if (!isPM && hours === 12) hours = 0;

            const pickupTime = new Date();
            pickupTime.setHours(hours, parseInt(pickupMinute));

            // Add duration in hours
            pickupTime.setHours(pickupTime.getHours() + duration);

            // Format return time
            const options = { hour: 'numeric', minute: '2-digit' };
            const formattedReturnTime = pickupTime.toLocaleTimeString([], options);

            // Set the returnTime dropdown to the closest matching option
            for (let i = 0; i < returnTimeSelect.options.length; i++) {
                if (returnTimeSelect.options[i].value === formattedReturnTime) {
                    returnTimeSelect.selectedIndex = i;
                    return;
                }
            }

            // If exact match not found, optionally set closest time or leave as is
            console.warn("No exact match found for return time.");
        }

        function updatereturndate() {
            debugger
            const selectedOption = document.getElementById("priceDropdown")?.options[
                document.getElementById("priceDropdown").selectedIndex
            ];
            const duration = selectedOption?.getAttribute("value");

            const pickupDateInput = document.getElementById("pickupDate");

            if (!pickupDateInput?.value || !duration) {
                console.error("Pickup date or duration is missing.");
                return;
            }

            const pickupDate = new Date(pickupDateInput.value);
            const returnDateInput = document.getElementById("returnDate");

            if (!returnDateInput) return;

            // Clone pickupDate and add hours
            const returnDate = new Date(pickupDate);
            returnDate.setHours(returnDate.getHours() + parseInt(duration));

            // Update only the return date
            returnDateInput.value = returnDate.toISOString().split("T")[0];
        }
        function markInvalid(id, condition, message) {
            const el = document.getElementById(id);
            const errorSpan = document.getElementById(id + "Error");

            if (condition) {
                el?.classList.add("input-error");
                if (errorSpan) {
                    errorSpan.textContent = message;
                    errorSpan.style.display = "block";
                }
            } else {
                el?.classList.remove("input-error");
                if (errorSpan) {
                    errorSpan.textContent = "";
                    errorSpan.style.display = "none";
                }
            }
        }
        window.submitBooking = submitBooking;
        window.updatereturndate = updatereturndate;
        window.updatereturntime = updatereturntime;

        async function submitBooking(button, cartName, cartId, cartType, description, deliveryLocation, returnLocation) {
            const formattedText = `
            You have booked${cartNameForDisplay}`;
            const name = document.getElementById("username").value.trim();
            const phone = document.getElementById("userphone").value.trim();
            const email = document.getElementById("useremail").value.trim();
            const pickupDate = document.getElementById("pickupDate").value;
            const pickupTime = document.getElementById("pickupTime").value;
            const returnDate = document.getElementById("returnDate").value;
            const returnTime = document.getElementById("returnTime").value;
            const priceDropdown = document.getElementById("priceDropdown").value;
            const selectedPrice = document.getElementById("selectedPrice").innerText;
            const userAddress = document.getElementById("userAddress").value;
            const roomNumber = document.getElementById("roomNumber").value;
            const deliverKey = document.getElementById("deliverKey").checked;

            let error = "";
            markInvalid("username", !name, "Name is required.");
            markInvalid("userphone", !phone || phone.length < 10, "Valid phone number is required.");
            markInvalid("useremail", !email || !/^\S+@\S+\.\S+$/.test(email), "Email address is required.");
            markInvalid("pickupDate", !pickupDate, "Pickup date is required.");
            markInvalid("pickupTime", !pickupTime, "Pickup time is required.");
            // markInvalid("returnDate", !returnDate, "Return date is required.");
            //markInvalid("returnTime", !returnTime, "Return time is required.");

            if (!name) error += "• Name is required.\n";
            if (!phone || phone.length < 10) error += "• Valid phone number is required.\n";
            if (!email || !/^\S+@\S+\.\S+$/.test(email)) error += "• Valid email address is required.\n";
            if (!pickupDate) error += "• Pickup date is required.\n";
            if (!pickupTime) error += "• Pickup time is required.\n";
            // if (!returnDate) error += "• Return date is required.\n";
            // if (!returnTime) error += "• Return time is required.\n";

            if (error) {
                // alert("Please fix the following:\n" + error);
                return;
            }
            button.disabled = true;
            const userid = 1; // You can get this from your login/auth flow
            var spinner = document.getElementById('typingIndicator')
            if (spinner != null) {
                spinner.style.display = 'inline-block';
                typingIndicator.style.display = 'block';
            }

            // Step 1: Check Cart Availability
            //if (!localStorage.getItem('userId')) {
            //    window.location.href = '/Login'
            //    return;
            //}
            const availabilityPayload = {
                PickUpDate: pickupDate,
                PickUpTime: pickupTime,
                ReturnDate: returnDate,
                ReturnTime: returnTime,
                AssetId: assetId, // passed in params
                companyId: localStorage.getItem('companyId') // your static company ID
            };

            try {
                const availabilityResponse = await fetch('https://stageapi.kotina.com/apigateway/ManageAsset/GetCartAvailability', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(availabilityPayload)
                });

                const availabilityData = await availabilityResponse.json();
                console.log('Availability:', availabilityData);

                if (!availabilityData || availabilityData.statusCode != 200) {
                    alert('Cart is not available for the selected dates/times.');
                    return;
                }
                var bookingResponse =null
                // Step 2: Proceed with Booking
                const bookingPayload = {
                    AssetId: assetId,
                    AspNetId: localStorage.getItem('userId'), // User's AspNetId (You can dynamically fetch after login)
                    CreatedBy: localStorage.getItem('userId'),
                    CompanyId: localStorage.getItem('companyId'),
                    cardnumber: "",
                    cardName: "",
                    cardExpMonth: "",
                    cardExpYear: "",
                    cardCvv: "",
                    CreditCardType: "",
                    pickUpDate: pickupDate,
                    returnDate: returnDate,
                    selectedGuest: "1 adults . 0 children . 0 pets . 1 room",
                    FirstName: name.split(' ')[0] || name,
                    LastName: name.split(' ')[1] || '',
                    BookingFlag: "StoreFrontGolfCartRentalBooking",
                    Nights: null,
                    TotalPrice: parseFloat(NetTotal),
                    City: userData != null ? userData.city : "test",
                    ZipCode: userData != null ? userData.zipCode : "3333",
                    Address: userAddress,
                    paymentGateWay: "AUTHORIZE",
                    PaymentMode: "CreditCard",
                    BookedRooms: null,
                    TotalRooms: null,
                    RoomId: null,
                    BookedRoomDetails: null,
                    BasePrice: parseFloat(basePrice),
                    SurchargePrice: null,
                    Tax: parseFloat(taxAmountTotal),
                    Discount: null,
                    AddonChargesDetail: null,
                    TotalBookedrooms: null,
                    Child: 0,
                    Adults: "1",
                    Pets: 0,
                    ChildAge: null,
                    pickUpTime: pickupTime,
                    returnTime: returnTime,
                    SelectedHours: "2 Hours",
                    InsuranceCharges: parseFloat(insuranceAmountTotal),
                    CartNumber: cartName,
                    payMode: "PayByCard",
                    isroomDeliveryAvaliable: deliverKey,
                    RoomNumber: roomNumber != null && roomNumber != '' ? roomNumber : null
                };
                if (userData == null || userData == undefined || userData == '') {
                    var userDataModel = {
                        FirstName: name.split(' ')[0] || name,
                        LastName: name.split(' ')[0] || name,
                        UserName: email,
                        Email: email,
                        PhoneNumber: phone,
                        address: userAddress,
                        address2: null,
                        County: null,
                        state: null,
                        city: userData != null ? userData.city : null,
                        zipCode: userData != null ? userData.zipCode : null,
                        Password: '@Password1#',
                        isTermAndCondition: true,
                        UserTypeId: '9da45acc-5bcd-4b91-b993-4239ecef29bb',
                        companyId: localStorage.getItem("companyId"),
                        CreatedBy: localStorage.getItem('userId'),
                        companyName: localStorage.getItem("companyName"),
                        logoLink: localStorage.getItem("companyLogo"),
                        StateName: userData != null ? userData.stateName : null,
                        FrexiCrmId: '',
                        CurrentSelectLanguage: localStorage.getItem('LanguageId'),
                        Notes: null,
                        countryCode: null
                    }
                    debugger;
                    let creatinguserResponse = await fetch('https://stageapi.kotina.com/apigateway/CompanyUsers/AddCompanyUsers', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userDataModel)
                    });
                    debugger;

                    const creatinguserResponseJson = await creatinguserResponse.json();
                    console.log('creatinguserResponse', creatinguserResponseJson);
                    bookingPayload.AspNetId = creatinguserResponseJson.id;
                    bookingPayload.CreatedBy = creatinguserResponseJson.id;
                    // alert(bookingPayload.AspNetId);
                    bookingResponse = await fetch('https://stageapi.kotina.com/apigateway/GolfCart/GolfCartRentalBooking', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(bookingPayload)
                    });
                }
                else {

                    bookingResponse = await fetch('https://stageapi.kotina.com/apigateway/GolfCart/GolfCartRentalBooking', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(bookingPayload)
                    });
                }

                const bookingData = await bookingResponse.json();
                console.log('Booking Response:', bookingData);

                if (bookingData && bookingData.statusCode == 200) {
                    const userid = localStorage.getItem('userId');
                    localStorage.removeItem('isBookingFromMaya');
                    localStorage.setItem('isBookingFromMaya', 'Yes');
                    //const formattedText = `
                    //You have booked
                    //<span class="hidden-text" style="color:#fff">
                    //- Cart Name: ${cartName}
                    //- Cart ID: ${assetId}
                    //- Cart Type: ${cartType}
                    //- Description: ${description}
                    //- Delivery Location: ${deliveryLocation}
                    //- Return Location: ${returnLocation}
                    //- Pickup Date: ${pickupDate}
                    //- Pickup Time: ${pickupTime}
                    //- Return Date: ${returnDate}
                    //- Return Time: ${returnTime}
                    //- Total Price: ${selectedPrice} (${priceDropdown})
                    //- Name: ${name}
                    //- Email: ${email}
                    //- Phone: ${phone}
                    //- User ID: ${userid}
                    //</span>`;

                    //$("#userInput").val(formattedText);
                    //sendMessage();
                    var spinner = document.getElementById('typingIndicator')
                    if (spinner != null) {
                        spinner.style.display = 'inline-block';
                        typingIndicator.style.display = 'none';
                    }
                    //addMessage(formattedText, 'user');
                    iframeUrl = 'https://stagepayments.kotina.com/paymentCard/index/' + bookingData.id + '/' + 'FRT';
                    const welcomeMessage = `
                 <iframe
               : src = "${iframeUrl}"
                 frameborder = "0"
                 class="iframe-content" > </iframe>`;
                    addMessage(welcomeMessage, 'bot');
                }

                else {
                    alert('Booking failed. Please try again.');
                }

            } catch (error) {
                console.error('Error:', error);
                alert('Something went wrong. Please try again.');
            }
        }



        function displayBotResponseWithAnimation(response) {
            debugger;
            console.log("Raw Response:", response);
            debugger;
            const chatMessages = document.getElementById("chatMessages");
            if (!chatMessages) {
                console.error("Chat messages container not found.");
                return;
            }
            debugger
            try {
                if (response.Intent === "Hotel_search") {
                    debugger;
                    if (!Array.isArray(response.sqlData) || response.sqlData.length === 0) {
                        appendBotMessage(response.response, chatMessages);
                        return;
                    }

                    appendBotMessage(response.response, chatMessages);


                    // Create the message container
                    const messageContainer = document.createElement("div");
                    messageContainer.classList.add("message-container");

                    // Bot Avatar
                    const botAvatar = document.createElement("img");
                    botAvatar.src = "robot.jpg";
                    botAvatar.alt = "Bot Avatar";
                    botAvatar.classList.add("bot-avatar");
                    messageContainer.appendChild(botAvatar);

                    // Bot message wrapper
                    const botMessageDiv = document.createElement("div");
                    botMessageDiv.classList.add("message", "bot");

                    // Main content wrapper
                    const mainBaseDiv = document.createElement("div");
                    mainBaseDiv.classList.add("mainbasediv");

                    // Group hotels by ID
                    const hotelsMap = {};
                    response.sqlData.forEach((room) => {
                        const hotelId = room.hotel_id;
                        if (!hotelsMap[hotelId]) {
                            hotelsMap[hotelId] = {
                                hotel_name: room.hotel_name,
                                location: room.location,
                                amenities: room.amenities || "Not specified",
                                rooms: []
                            };
                        }

                        // Process room images
                        let images = [];
                        if (room.images) {
                            images = room.images
                                .replace(/\\/g, "/")
                                .split(",")
                                .map(img => img.trim())
                                .filter(img => img);
                        }
                        if (!images.length || images[0] === "None") {
                            images = ["https://www.shutterstock.com/image-vector/no-pictures-icon-hotel-restaurant-260nw-2270297227.jpg"];
                        }

                        hotelsMap[hotelId].rooms.push({
                            room_id: room.room_id,
                            room_type: room.room_type,
                            bed_type: room.bed_type,
                            price: room.price_per_night,
                            images: images,
                            availability: room.is_available,
                            taxes: room.taxes,
                        });
                    });

                    // Iterate over each hotel and build card layout
                    Object.keys(hotelsMap).forEach((hotelId) => {
                        const hotel = hotelsMap[hotelId];
                        const hotelCard = document.createElement("div");
                        hotelCard.classList.add("hotel-card");

                        // Unique carousel id for each hotel
                        const carouselId = `hotelCarousel_${hotelId}`;
                        let carouselItems = "";

                        // Build carousel items for each room
                        hotel.rooms.forEach((room, index) => {
                            const imagesHtml = room.images.map(image => `
                            <img src="${image}" alt="Room Image" class="carousel-image"/>
                        `).join("");

                            carouselItems += `
                            <div class="carousel-item ${index === 0 ? "active" : ""}">
                                <div class="room-info">
                                    <h6>${room.room_type}</h6>
                                    <p>(${room.bed_type})</p>
                                    <p class="availability">✅ Available: ${room.availability === 1 ? "✅ YES" : "NO"}</p>
                                    <p class="price">💰 $${room.price} / night</p>
                                </div>
                                <div class="room-images">
                                    ${imagesHtml}
                                </div>

                                <button class="btn-soldout" style="display: ${room.availability === 1 ? "none" : "block"}">
                                    SOLD OUT
                                </button>

                                <button class="btn-book" style="display: ${room.availability === 1 ? "block" : "none"}" data-attribute="${room.room_type}^${hotelId}^${room.room_id}^${hotel.hotel_name}^${room.price}^${room.taxes}^${room.images}">
                                Book now for $${room.price}
                            </button>

                            </div>
                        `;
                        });

                        hotelCard.innerHTML = `
                        <div class="hotel-header">
                            <h5>🏨 ${hotel.hotel_name}</h5>
                            <p class="hotel-location">📍 ${hotel.location}</p>
                            <p class="hotel-amenities">🎉 ${hotel.amenities}</p>
                        </div>
                        <div id="${carouselId}" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                ${carouselItems}
                            </div>
                            ${hotel.rooms.length > 1 ? `
                                <button class="carousel-control-prev" type="button" data-bs-target="#${carouselId}" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#${carouselId}" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            ` : ""}
                        </div>
                    `;

                        mainBaseDiv.appendChild(hotelCard);
                        setTimeout(() => {
                            hotelCard.style.opacity = "1";
                        }, 100);
                    });

                    // Append the main content to the bot message wrapper and message container
                    botMessageDiv.appendChild(mainBaseDiv);
                    messageContainer.appendChild(botMessageDiv);
                    chatMessages.appendChild(messageContainer);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }

                else if (response.Intent === "cart_search") {
                    debugger
                    const rawcarts = response.sqlData;
                    let parsedData = JSON.parse(rawcarts);
                    let carts = JSON.parse(parsedData.response);

                    const messageContainer = document.createElement("div");
                    messageContainer.classList.add("message-container");

                    // Bot Avatar
                    const botAvatar = document.createElement("img");
                    botAvatar.src = "robot.jpg";
                    botAvatar.alt = "Bot Avatar";
                    botAvatar.classList.add("bot-avatar");
                    messageContainer.appendChild(botAvatar);

                    const botMessageDiv = document.createElement("div");
                    botMessageDiv.classList.add("message", "bot");

                    const cartWrapper = document.createElement("div");
                    cartWrapper.id = "cartRentalContainer";
                    cartWrapper.classList.add("cart-container");

                    const header = document.createElement("h3");
                    header.classList.add("text-left");
                    header.classList.add("p-2");

                    header.innerText = "  Available Carts for Rent";
                    cartWrapper.appendChild(header);

                    const cartSection = document.createElement("div");
                    cartSection.classList.add("cart-sections");
                    carts.forEach((cart, index) => {
                        debugger
                        // Parse and sanitize image URLs
                        let images = [];
                        if (Array.isArray(cart.ImagePaths)) {
                            images = cart.ImagePaths
                                .map(obj => obj.ImagePath?.trim().replace(/\\/g, "/"))
                                .filter((img, idx, arr) =>
                                    img &&
                                    img.toLowerCase() !== "none" &&
                                    arr.indexOf(img) === idx
                                );
                        } else if (typeof cart.ImagePaths === 'string') {
                            // Fallback if string format is ever returned
                            images = cart.ImagePaths
                                .split(",")
                                .map(img => img.trim().replace(/\\/g, "/"))
                                .filter((img, idx, arr) =>
                                    img &&
                                    img.toLowerCase() !== "none" &&
                                    arr.indexOf(img) === idx
                                );
                        }

                        // Fallback image if none valid
                        if (images.length === 0) {
                            images.push("https://www.shutterstock.com/image-vector/no-pictures-icon-hotel-restaurant-260nw-2270297227.jpg");
                        }

                        const carouselId = `cartCarousel_${index}`;
                        const carouselItems = images.map((image, idx) => `
                            <div class="carousel-item ${idx === 0 ? 'active' : ''}">
                                <img src="${image}" class="d-block w-100 carousel-image" alt="Cart Image ${idx + 1}">
                            </div>
                        `).join("");

                        // Prepare additional fallback values
                        const address = cart.address || "No address provided";
                        const price = cart.price ? `$${cart.price}` : "Not available";
                        const weeklyRate = cart.weekly_rate ? `$${cart.weekly_rate}` : "Not available";
                        const createdAt = new Date(cart.created_at).toLocaleDateString() || "No date available";

                        const rawDescription = typeof cart.Description === "string" ? cart.Description : "";
                        const words = rawDescription.trim().split(/\s+/);
                        const shortDescription = words.slice(0, 100).join(" ") + (words.length > 100 ? "..." : "");


                        const cartCard = document.createElement("div");
                        cartCard.classList.add("cart-card");
                        cartCard.innerHTML = `
                         <h4>${cart.name}</h4>
 
                     <div class="py-1"><strong>Type:</strong> ${cart.name || "Not specified"}</div>
                    <!--<div><strong>Description:</strong> <p>${shortDescription || "No description available"}</p></div>-->
                    <div class="py-1"><strong>Address:</strong> ${address}</div>
                      <div class="py-1"><strong>Price For 2 Hour:</strong> ${price}</div>


            <div id="${carouselId}" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                    ${carouselItems}
                </div>
                ${images.length > 1 ? `
                    <button class="carousel-control-prev" type="button" data-bs-target="#${carouselId}" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#${carouselId}" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                ` : ""}
            </div>

            <button class="btn-book" onclick='bookCart(${JSON.stringify(cart)})'>Book Now</button>
        `;

                        cartSection.appendChild(cartCard);
                    });

                    cartWrapper.appendChild(cartSection);
                    botMessageDiv.appendChild(cartWrapper);
                    messageContainer.appendChild(botMessageDiv);
                    chatMessages.appendChild(messageContainer);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }

                else if (response.Intent === "select_hotel") {
                    if (!Array.isArray(response.sqlData) || response.sqlData.length === 0) {
                        appendBotMessage(response.response, chatMessages);
                        return;
                    }

                    // Create the message container
                    const messageContainer = document.createElement("div");
                    messageContainer.classList.add("message-container");

                    // Bot Avatar
                    const botAvatar = document.createElement("img");
                    botAvatar.src = "robot.jpg";
                    botAvatar.alt = "Bot Avatar";
                    botAvatar.classList.add("bot-avatar");
                    messageContainer.appendChild(botAvatar);

                    // Bot message wrapper
                    const botMessageDiv = document.createElement("div");
                    botMessageDiv.classList.add("message", "bot");

                    // Add bot's greeting message before showing hotels
                    const greetingMessage = document.createElement("p");
                    greetingMessage.classList.add("bot-greeting");
                    greetingMessage.innerText = "May I kindly request you the Hotel name to assist you with your food request? 😊 ✨";
                    botMessageDiv.appendChild(greetingMessage);

                    // Hotel selection container
                    const hotelListContainer = document.createElement("div");
                    hotelListContainer.classList.add("hotel-list-container");

                    // Iterate over each hotel and create a clickable card
                    response.sqlData.forEach((hotel) => {
                        const hotelItem = document.createElement("div");
                        hotelItem.classList.add("hotel-item");
                        hotelItem.setAttribute("data-hotel-id", hotel.id);

                        hotelItem.innerHTML = `
                        <span class="hotel-title">${hotel.name}</span>
                    `;

                        // Add click event listener to send hotel_id
                        hotelItem.addEventListener("click", () => {
                            sendHotelSelection(hotel.id, hotel.name);
                        });

                        hotelListContainer.appendChild(hotelItem);
                    });

                    // Append the hotel selection container to the bot message wrapper
                    botMessageDiv.appendChild(hotelListContainer);
                    messageContainer.appendChild(botMessageDiv);
                    chatMessages.appendChild(messageContainer);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
                else if (response.Intent === "booking_Inquery") {
                    var htmlContent = '';
                    try {
                        const bookingData = JSON.parse(response.response); // or JSON.parse(response.res) if needed

                        // Map JSON fields to variables for easy usage
                        const cartName = bookingData.AssetName || bookingData.HotelName || "";
                        const paymentDate = bookingData.PaymentDate || "";
                        const cartType = bookingData.AssetName || ""; // (You might need to adjust if there's a specific cartType field)
                        const description = bookingData.CompanyName || ""; // (Or any description field if you have)
                        const deliveryLocation = bookingData.CompanyAddress || "";
                        const returnLocation = bookingData.CompanyAddress || ""; // (if different, use another field)
                        const pickupDate = bookingData.CheckInDate || "";
                        const pickupTime = bookingData.PickupTime || "";
                        const returnDate = bookingData.CheckOutDate || "";
                        const returnTime = bookingData.ReturnTime || "";
                        //const selectedPrice = bookingData.TotalAmount || "";
                        //const priceDropdown = bookingData.PaymentMode || "";
                        const name = bookingData.FirstName + " " + bookingData.LastName;
                        const email = bookingData.Email || "";
                        const phone = bookingData.PhoneNumber || "";
                        const Address = bookingData.Address || "";
                        const TotalAmount = bookingData.TotalAmount || "";

                        // Now build your HTML dynamically
                                             htmlContent = `
                      <span  style="color:black">
                         Cart Name: ${cartName}<br>
                         Description: ${description}<br>
                         Delivery Location: ${deliveryLocation}<br>
                         Return Location: ${returnLocation}<br>
                         Payment Date: ${paymentDate}<br>
                         Pickup Date: ${pickupDate}<br>
                         Pickup Time: ${pickupTime}<br>
                         Return Date: ${returnDate}<br>
                         Return Time: ${returnTime}<br>
                         Total Price: $ ${TotalAmount}<br>
                         Name: ${name}<br>
                         Email: ${email}<br>
                         Phone: ${phone}<br>
                         Address: ${Address}<br>
                      </span>
                    `;
                    } catch (e) {
                        htmlContent = response.response;
                    }

                    // Create the message container and inject the dynamic HTML
                    const messageContainer = document.createElement("div");
                    messageContainer.classList.add("message-container");

                    const botAvatar = document.createElement("img");
                    botAvatar.src = "robot.jpg";
                    botAvatar.alt = "Bot Avatar";
                    botAvatar.classList.add("bot-avatar");

                    const messageDiv = document.createElement("div");
                    messageDiv.classList.add("markdown", "message", "bot");
                    messageDiv.id = "message-" + Date.now();
                    messageDiv.innerHTML = `<div class="markdown-content">${htmlContent}</div>`;

                    // Append everything
                    messageContainer.appendChild(botAvatar);
                    messageContainer.appendChild(messageDiv);
                    chatMessages.appendChild(messageContainer);

                    // Scroll to latest message
                    chatMessages.scrollTo({ top: chatMessages.scrollHeight, behavior: "smooth" });


                }
                else if (response.Intent === "Hotel_Menu") {
                    debugger;
                    console.log(response.sqlData);

                    const menuItems = response.sqlData; // Extract menu items array

                    // Remove any existing menu container before adding a new one
                    const existingMenu = document.getElementById("hotelMenuContainer");
                    if (existingMenu) {
                        existingMenu.remove();
                    }

                    // Grouping menu items by meal type
                    const groupedMenu = {};
                    menuItems.forEach((item) => {
                        if (!groupedMenu[item.meal_type]) {
                            groupedMenu[item.meal_type] = [];
                        }
                        groupedMenu[item.meal_type].push(item);
                    });

                    // Start building menu HTML
                    let menuHTML = `
            <div id="hotelMenuContainer" class="menu-container">
                <h3 class="text-center">🍽️ Today's Menu</h3>
                <div class="menu-sections">
            `;

                    // Loop through meal types and generate sections
                    for (const mealType in groupedMenu) {
                        menuHTML += `
                <div class="menu-section">
                    <div class="meal-title">${mealType}</div>
                    <table class="table table-bordered text-center" style="font-size: 12px;">
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Image</th>
                                <th>Dish Name</th>
                                <th>Diet</th>
                                <th>Price</th>
                                <th>Allergens</th>
                                <th>Prep Time</th>
                                <th>Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                `;

                        // Loop through dishes in this meal type
                        groupedMenu[mealType].forEach((dish) => {
                            // Safely encode data to prevent syntax errors
                            const safeImage = encodeURIComponent(dish.image);
                            const safeName = encodeURIComponent(dish.name);
                            const safeNutrition = encodeURIComponent(dish.nutrition);
                            const safeDietInfo = encodeURIComponent(dish.diet_info);

                            menuHTML += `
                                <tr>
                                    <td><input type="checkbox" class="dish-checkbox" data-price="${dish.price}" onchange="calculateTotal()"></td>
                                    <td>
                                        <img src="${dish.image}" alt="${dish.name}" class="menu-img"
                                            onclick="showImagePopup(decodeURIComponent('${safeImage}'), decodeURIComponent('${safeName}'), decodeURIComponent('${safeNutrition}'), decodeURIComponent('${safeDietInfo}'))">
                                    </td>
                                    <td style="cursor: pointer;"
                                        onclick="showImagePopup(decodeURIComponent('${safeImage}'), decodeURIComponent('${safeName}'), decodeURIComponent('${safeNutrition}'), decodeURIComponent('${safeDietInfo}'))">
                                        ${dish.name}
                                    </td>
                                    <td>${dish.diet}</td>
                                    <td>$${dish.price.toFixed(2)}</td>
                                    <td>${dish.allergens}</td>
                                    <td>${dish.preparation_time} min</td>
                                    <td>
                                        <input type="number" class="form-control qty-input" style="width: 60px; font-size: 11px;" min="1" max="${dish.quantity}" value="1" onchange="calculateTotal()">
                                    </td>
                                </tr>
                    `;
                        });

                        menuHTML += `</tbody></table></div>`; // Close meal type section
                    }

                    menuHTML += `</div>`; // Close menu sections

                    // Add the footer inside the same container
                    menuHTML += `
                    <div class="footer">
                        <div class="details" style="font-size: 12px;">
                            <div><strong>Total:</strong> $<span id="total-price">0.00</span></div>
                            <div><strong>Tax (10%):</strong> $<span id="tax-amount">0.00</span></div>
                            <div><strong>Discount (5% if > $50):</strong> $<span id="discount-amount">0.00</span></div>
                            <div><strong>Final Total:</strong> $<span id="final-total">0.00</span></div>
                        </div>
                        <div class="buttons">
                            <button class="btn-book" onclick="bookOrder()">Book Order</button>
                            <button class="btn-clear" onclick="clearOrder()">Clear Order</button>
                        </div>
                    </div>
                    </div>`; // Close menu container

                    // Create chatbot message container
                    const messageContainer = document.createElement("div");
                    messageContainer.classList.add("message-container");

                    // Bot Avatar (optional)
                    const botAvatar = document.createElement("img");
                    botAvatar.src = "robot.jpg";
                    botAvatar.alt = "Bot Avatar";
                    botAvatar.classList.add("bot-avatar");
                    messageContainer.appendChild(botAvatar);

                    // Bot message wrapper
                    const botMessageDiv = document.createElement("div");
                    botMessageDiv.classList.add("message", "bot");

                    // Insert the menu HTML
                    botMessageDiv.innerHTML = menuHTML;

                    // Append to chat messages
                    messageContainer.appendChild(botMessageDiv);
                    chatMessages.appendChild(messageContainer);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }

                else if (response.Intent === "Booking_confirmation") {
                    console.log(response.sqlData)
                    //const bookingID = response.sqlData.bookingID;
                    const hotelName = response.sqlData.hotel_name;
                    const checkinDate = response.sqlData.checkinDate;
                    const checkoutDate = response.sqlData.checkoutDate;
                    const totalPrice = response.sqlData.total_price;
                    const roomType = response.sqlData.room_type;
                    //const bookingRefrence = response.sqlData.room_id;
                    const bookingRefrence = response.sqlData.bookingRefrence;

                    // Replace with your actual image URL from the backend
                    const roomImageUrl = response.sqlData.image;

                    const confirmationMessage = `
                    <div class="booking-confirmation-card">
                    <!-- Header -->
                    <div class="confirmation-header">
                    <h3>Booking Confirmation</h3>
                    <p>Thank you for your booking! Your reservation has been successfully confirmed.</p>
                    </div>

                    <!-- Body with two columns: details (left) + image (right) -->
                    <div class="confirmation-body">
                    <div class="confirmation-details">
                    <p class="detail-line">
                    <span class="label">Hotel Name:</span>
                    <span class="value">${hotelName} \u{1F3E8}</span>
                    </p>
                    <p class="detail-line">
                    <span class="label">Check-in Date:</span>
                    <span class="value">${checkinDate} \u{1F4C5}</span>
                    </p>
                    <p class="detail-line">
                    <span class="label">Check-out Date:</span>
                    <span class="value">${checkoutDate} \u{1F4C5}</span>
                    </p>
                    <p class="detail-line">
                    <span class="label">Total Price:</span>
                    <span class="value">$${totalPrice.toFixed(2)} \u{1F4B0}</span>
                    </p>
                    <p class="detail-line">
                    <span class="label">Room Type:</span>
                    <span class="value">${roomType} \u{1F6CC}</span>
                    </p>
                    <p class="detail-line">
                    <span class="label">Booking Ref:</span>
                    <span class="value">${bookingRefrence} \u{1F6AA}</span>
                    </p>
                    </div>
                    <div class="confirmation-image">
                    <img src="${roomImageUrl}" alt="Room Image" class="room-images" style="height: 310px; width: 465px;" />
                    </div>
                    </div>

                    <!-- Footer -->
                    <div class="confirmation-footer">
                    <p>Thank you for your visit \u{2728}\u{1F334}</p>
                    </div>
                    </div>
                    `;

                    // Example of appending the confirmation to your chat container:
                    const messageContainer = document.createElement("div");
                    messageContainer.classList.add("message-container");

                    // Bot Avatar (optional)
                    const botAvatar = document.createElement("img");
                    botAvatar.src = "robot.jpg";
                    botAvatar.alt = "Bot Avatar";
                    botAvatar.classList.add("bot-avatar");
                    messageContainer.appendChild(botAvatar);

                    // Bot message wrapper
                    const botMessageDiv = document.createElement("div");
                    botMessageDiv.classList.add("message", "bot");

                    // Insert the confirmation HTML
                    botMessageDiv.innerHTML = confirmationMessage;

                    // Append to your chat messages
                    messageContainer.appendChild(botMessageDiv);
                    chatMessages.appendChild(messageContainer);
                    chatMessages.scrollTop = chatMessages.scrollHeight;


                }
                // cart rate
                else if (response.Intent === "cart_rates") {
                    let html = `
                    <div style="text-align:center;margin-bottom:12px">
                        <h3 style="color:#e46726;font-size:18px;margin:0;font-weight:600">
                            Golf Cart Rates
                        </h3>
                    </div>`;

                    const carts = response.sqlData;

                    if (!carts || carts.length === 0) {
                        html += `<p style="text-align:center;color:#888">No rate information available.</p>`;
                    } else {
                        carts.forEach(group => {
                            const rates = group.cartRatesJson;
                            if (!rates || !rates.length) return;

                            html += `
                            <div style="
                                margin-bottom:18px;
                                background:white;
                                border-radius:16px;
                                overflow:hidden;
                                box-shadow:0 4px 12px rgba(0,0,0,0.08);
                                border:1px solid #e46726;
                            ">
                                <!-- Header -->
                                <div style="
                                    background:linear-gradient(135deg, #e46726 0%, #e46726 100%);
                                    color:white;
                                    padding:10px 14px; /* reduced */
                                    text-align:center;
                                ">
                                    <div style="
                                        font-size:15px; /* slightly reduced */
                                        font-weight:700;
                                        letter-spacing:0.2px;
                                        line-height:1.25; /* tighter */
                                        word-break:break-word;
                                        max-width:220px;
                                        margin:0 auto;
                                    ">
                                        ${group.cartName}
                                    </div>
                                </div>

                                <!-- Table -->
                                <table style="width:100%;font-size:13px;border-collapse:collapse">
                                    <tr style="background:#f1f5f9;border-bottom:1px solid #e2e8f0">
                                        <th style="padding:8px 16px;text-align:left;font-weight:600;color:#201f1d">
                                            Duration
                                        </th>
                                        <th style="padding:8px 16px;text-align:right;font-weight:600;color:#201f1d">
                                            Rate
                                        </th>
                                    </tr>

                                    ${rates.map((row, i) => `
                                    <tr style="
                                        background:${i % 2 === 0 ? '#ffffff' : '#f8fafc'};
                                        border-bottom:1px solid #f0f0f0;
                                    ">
                                        <td style="padding:6px 16px;color:#334155;font-weight:500">
                                            <span style="
                                                display:inline-block;
                                                background:#79797959;
                                                padding:2px 6px; /* reduced */
                                                border-radius:14px;
                                                font-size:11px;
                                                color:#201f1d;
                                                line-height:1.2;
                                            ">
                                                ${row.duration ?? '-'}
                                            </span>
                                        </td>

                                        <td style="
                                            padding:6px 16px;
                                            text-align:right;
                                            font-weight:700;
                                            color:#201f1d;
                                            font-size:13px;
                                        ">
                                            $${typeof row.price === 'number' ? row.price.toFixed(2) : row.price ?? '-'}
                                        </td>
                                    </tr>
                                    `).join("")}
                                </table>

                                <!-- Footer -->
                                <div style="
                                    background:#eff6ff;
                                    padding:5px 16px; /* reduced */
                                    border-top:1px solid #dbeafe;
                                "></div>
                            </div>`;
                        });
                    }

                    const mc = document.createElement("div");
                    mc.classList.add("message-container");

                    const av = document.createElement("img");
                    av.src = "Robot.jpg";
                    av.classList.add("bot-avatar");
                    mc.appendChild(av);

                    const md = document.createElement("div");
                    md.classList.add("message", "bot");
                    md.innerHTML = html;

                    mc.appendChild(md);
                    chatMessages.appendChild(mc);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
                    // cart cart_availability
                else if (response.Intent === "cart_availability") {
                    const carts = response.sqlData;
                    const summaryText = response.response || "Here is the cart availability:";

                    let html = `<p style="margin-bottom:15px;font-weight:600;font-size:14px">${summaryText}</p>`;

                    if (!Array.isArray(carts) || carts.length === 0) {
                        html += `<p style="color:#888;text-align:center"></p>`;
                    } else {
                        carts.forEach(cart => {
                            const availList = cart.availabilityList || [];

                            html += `
                            <div style="margin-bottom:20px;">
                                <div style="background:#e46726;color:white;padding:10px 15px;font-size:14px;font-weight:600;border-radius:8px 8px 0 0;">
                                    ${cart.cartName}
                                </div>
                                <div style="border:1px solid #e0e0e0;border-top:none;padding:15px;border-radius:0 0 8px 8px;background:#fafafa;">
                                    <div style="display:grid;grid-template-columns:repeat(7,1fr);gap:8px;margin-bottom:10px;">
                                        <div style="text-align:center;font-weight:600;color:#666;font-size:11px;">Sun</div>
                                        <div style="text-align:center;font-weight:600;color:#666;font-size:11px;">Mon</div>
                                        <div style="text-align:center;font-weight:600;color:#666;font-size:11px;">Tue</div>
                                        <div style="text-align:center;font-weight:600;color:#666;font-size:11px;">Wed</div>
                                        <div style="text-align:center;font-weight:600;color:#666;font-size:11px;">Thu</div>
                                        <div style="text-align:center;font-weight:600;color:#666;font-size:11px;">Fri</div>
                                        <div style="text-align:center;font-weight:600;color:#666;font-size:11px;">Sat</div>
                                    </div>
                                    <div style="display:grid;grid-template-columns:repeat(7,1fr);gap:8px;">
                            `;

                            // Add empty cells for days before the first date (if needed)
                            if (availList.length > 0) {
                                const firstDate = new Date(availList[0].date);
                                const firstDayOfWeek = firstDate.getDay();
                                for (let i = 0; i < firstDayOfWeek; i++) {
                                    html += `<div></div>`;
                                }
                            }

                            availList.forEach((entry, index) => {
                                const isAvailable = entry.status === "Available";
                                const dateObj = new Date(entry.date);
                                const dayNumber = dateObj.getDate();
                                const monthDay = dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                                debugger;
                                if (isAvailable) {
                                    // Available - Green box, clickable - SMALLER PADDING
                                    html += `
                                        <div onclick="bookCartFromAvailability('${cart.cartName}', '${cart.cart_id || cart.id}', '${entry.date}', '${cart.categoryName || 'Golf Cart'}', '${cart.description || ''}')" 
                                            style="background:#4CAF50;color:white;padding:8px 4px;text-align:center;border-radius:6px;cursor:pointer;font-weight:600;font-size:12px;transition:all 0.3s;box-shadow:0 1px 3px rgba(0,0,0,0.1);"
                                            onmouseover="this.style.background='#45a049';this.style.transform='scale(1.02)'"
                                            onmouseout="this.style.background='#4CAF50';this.style.transform='scale(1)'">
                                            <div style="font-size:13px;font-weight:700;">${entry.availableCartCount}</div>
                                            <div style="font-size:8px;opacity:0.9;">${monthDay}</div>
                                            <div style="font-size:7px;opacity:0.8;margin-top:2px;">available</div>
                                        </div>
                                    `;
                                } else {
                                    // Unavailable - Grey box, not clickable - SMALLER PADDING
                                    html += `
                                        <div style="background:#e0e0e0;color:#999;padding:8px 4px;text-align:center;border-radius:6px;cursor:not-allowed;font-weight:600;font-size:12px;opacity:0.7;">
                                            <div style="font-size:13px;font-weight:700;">0 </div>
                                            <div style="font-size:8px;opacity:0.8;">${monthDay}</div>
                                        </div>
                                    `;
                                }
                            });

                            html += `
                                    </div>
                                    <div style="margin-top:12px;display:flex;gap:15px;justify-content:center;font-size:11px;">
                                        <div style="display:flex;align-items:center;gap:5px;">
                                            <div style="width:12px;height:12px;background:#4CAF50;border-radius:3px;"></div>
                                            <span>Available</span>
                                        </div>
                                        <div style="display:flex;align-items:center;gap:5px;">
                                            <div style="width:12px;height:12px;background:#e0e0e0;border-radius:3px;"></div>
                                            <span>Unavailable</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            `;
                        });
                    }

                    const mc = document.createElement("div");
                    mc.classList.add("message-container");
                    const av = document.createElement("img");
                    av.src = "Robot.jpg";
                    av.classList.add("bot-avatar");
                    mc.appendChild(av);
                    const md = document.createElement("div");
                    md.classList.add("message", "bot");
                    md.innerHTML = html;
                    mc.appendChild(md);
                    chatMessages.appendChild(mc);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }

                else {
                    appendBotMessage(response.response, chatMessages);
                }
            } catch (error) {
                console.error("Error parsing JSON response:", error);
                appendBotMessage("Something went wrong. Please try again.", chatMessages);
            }
        }

        function truncateDescription(text, maxWords = 100) {
            if (!text) return "No description available";
            const words = text.trim().split(/\s+/);
            if (words.length <= maxWords) return text;
            return words.slice(0, maxWords).join(" ") + "...";
        }

        function extractBookingDetails(text) {
            const details = {
                bookingID: text.match(/\*\*Booking ID:\*\*\s*(\d+)/)?.[1] || "Not found",
                hotelName: text.match(/\*\*Hotel Name:\*\*\s*(.+)/)?.[1] || "Not found",
                roomType: text.match(/\*\*Room Type:\*\*\s*(.+)/)?.[1] || "Not found",
                guestName: text.match(/\*\*Guest Name:\*\*\s*(.+)/)?.[1] || "Not found",
                email: text.match(/\*\*Email:\*\*\s*([\w\.\-]+@[\w\.\-]+\.\w+)/)?.[1] || "Not found",
                phone: text.match(/\*\*Phone:\*\*\s*(\d+)/)?.[1] || "Not found",
                checkInDate: text.match(/\*\*Check-in Date:\*\*\s*(\d{4}-\d{2}-\d{2})/)?.[1] || "Not found",
                checkOutDate: text.match(/\*\*Check-out Date:\*\*\s*(\d{4}-\d{2}-\d{2})/)?.[1] || "Not found",
                numGuests: text.match(/\*\*Number of Guests:\*\*\s*(.+)/)?.[1] || "Not found",
                totalPrice: text.match(/\*\*Total Price:\*\*\s*\$([\d\.]+)/)?.[1] || "Not found",
                roomNumber: text.match(/\*\*Room Number:\*\*\s*(\d+)/)?.[1] || "Not found",
                hotelID: text.match(/\*\*Hotel ID:\*\*\s*(\d+)/)?.[1] || "Not found"
            };

            return details;
        }

        function appendBotMessage(formattedText, container) {
            // Create message container
            const messageContainer = document.createElement("div");
            messageContainer.classList.add("message-container");

            // Create bot avatar
            const botAvatar = document.createElement("img");
            botAvatar.src = "robot.jpg";
            botAvatar.alt = "Bot Avatar";
            botAvatar.classList.add("bot-avatar");

            // Create message div
            const messageDiv = document.createElement("div");
            messageDiv.classList.add("markdown", "message", "bot");
            messageDiv.id = "message-" + Date.now(); // Ensure unique ID

            // Ensure proper Markdown formatting (especially for tables)
            let correctedMarkdown = formattedText.trim(); // Trim unnecessary spaces
            correctedMarkdown = correctedMarkdown.replace(/\n/g, '<br/>'); // Fix table row formatting

            // Convert markdown text to HTML
            const formattedMarkdown = marked.parse(correctedMarkdown);

            // Set message content
            messageDiv.innerHTML = `<div class="markdown-content">${formattedMarkdown}</div>`;

            // Append elements
            messageContainer.appendChild(botAvatar);
            messageContainer.appendChild(messageDiv);
            container.appendChild(messageContainer);

            // Auto-scroll to the latest message smoothly
            container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
        }
        window.convertToHours = convertToHours;
        function convertToHours(text) {
            const value = parseInt(text);

            if (text.includes("Hour")) return value;
            if (text.includes("Day")) return value * 24;
            if (text.includes("Week")) return value * 7 * 24;

            return 0;
        }

        //async function loadCartPrices(cartId) {
        //    //alert(cartId);
        //    var prices = [];
        //    //const res = await fetch(`https://chatbot.talygen.com/cartPriceDropdown/?cart_id=${cartId}`);
        //    const res = await fetch(`https://stageapi.kotina.com/apigateway/userList/GetMasterItems/GolfCartRates/GolfCartRates/${cartId}`);
        //    const data = await res.json();
        //    debugger;
        //    if (cartId == 1) {
        //        prices = [
        //            { price_id: 23, priceper_hours: 35.0, cart_id: 1, hours: "2 Hours", total_Hours: 2 },
        //            { price_id: 24, priceper_hours: 45.0, cart_id: 1, hours: "4 Hours", total_Hours: 4 },
        //            { price_id: 25, priceper_hours: 55.0, cart_id: 1, hours: "8 Hours", total_Hours: 8 },
        //            { price_id: 26, priceper_hours: 80.0, cart_id: 1, hours: "1 Day", total_Hours: 24 },
        //            { price_id: 27, priceper_hours: 140.0, cart_id: 1, hours: "2 Days", total_Hours: 48 },
        //            { price_id: 28, priceper_hours: 195.0, cart_id: 1, hours: "3 Days", total_Hours: 72 },
        //            { price_id: 29, priceper_hours: 235.0, cart_id: 1, hours: "4 Days", total_Hours: 96 },
        //            { price_id: 30, priceper_hours: 270.0, cart_id: 1, hours: "5 Days", total_Hours: 120 },
        //            { price_id: 31, priceper_hours: 290.0, cart_id: 1, hours: "6 Days", total_Hours: 144 },
        //            { price_id: 32, priceper_hours: 320.0, cart_id: 1, hours: "1 Week", total_Hours: 168 },
        //            { price_id: 33, priceper_hours: 525.0, cart_id: 1, hours: "2 Weeks", total_Hours: 336 }
        //        ]
        //    } else if (cartId == 2) {
        //        prices = [
        //            { price_id: 34, priceper_hours: 45.0, cart_id: 2, hours: "2 Hours", total_Hours: 2 },
        //            { price_id: 35, priceper_hours: 65.0, cart_id: 2, hours: "4 Hours", total_Hours: 4 },
        //            { price_id: 36, priceper_hours: 80.0, cart_id: 2, hours: "8 Hours", total_Hours: 8 },
        //            { price_id: 37, priceper_hours: 114.7, cart_id: 2, hours: "1 Day", total_Hours: 24 },
        //            { price_id: 38, priceper_hours: 225.8, cart_id: 2, hours: "2 Day", total_Hours: 48 },
        //            { price_id: 39, priceper_hours: 310.25, cart_id: 2, hours: "3 Days", total_Hours: 72 },
        //            { price_id: 40, priceper_hours: 363.6, cart_id: 2, hours: "4 Days", total_Hours: 96 },
        //            { price_id: 41, priceper_hours: 425.8, cart_id: 2, hours: "5 Days", total_Hours: 120 },
        //            { price_id: 42, priceper_hours: 461.4, cart_id: 2, hours: "6 Days", total_Hours: 144 },
        //            { price_id: 43, priceper_hours: 506.7, cart_id: 2, hours: "1 Week", total_Hours: 168 },
        //            { price_id: 44, priceper_hours: 985.0, cart_id: 2, hours: "2 Weeks", total_Hours: 336 },
        //            { price_id: 45, priceper_hours: 92.5, cart_id: 2, hours: "10 Hours", total_Hours: 10 }
        //        ];
        //    }
        //    //if (data.status === 'success') {
        //        const dropdown = document.getElementById('priceDropdown');
        //        dropdown.innerHTML = '<option value="">-- Select --</option>'; // Clear previous
        //        data.prices = prices;
        //        data.prices.forEach(price => {
        //            const option = document.createElement('option');
        //            option.value = price.total_Hours;
        //            option.textContent = `${price.hours}`;
        //            option.dataset.price = price.priceper_hours;
        //            dropdown.appendChild(option);
        //        });

        //        // Add listener to update price display
        //        dropdown.addEventListener('change', function () {

        //            const selected = dropdown.options[dropdown.selectedIndex];
        //            const price = selected?.dataset?.price ? parseFloat(selected.dataset.price).toFixed(2) : '$0.00';
        //            const taxAmount = selected?.dataset?.price ? (parseFloat(selected.dataset.price) * parseFloat(tax) / 100).toFixed(2) : '$0.00';
        //            const insuranceAmount = selected?.dataset?.price ? (parseFloat(selected.dataset.price) * parseFloat(insurance) / 100).toFixed(2) : '$0.00';


        //            const totalAmount = selected?.dataset?.price
        //                ? (parseFloat(price) + parseFloat(taxAmount) + parseFloat(insuranceAmount)).toFixed(2)
        //                : '$0.00';
        //            taxAmountTotal = taxAmount;
        //            insuranceAmountTotal = insuranceAmount;
        //            basePrice = price;
        //            NetTotal = totalAmount

        //            document.getElementById('selectedPrice').textContent = `$${price}`;
        //            document.getElementById('selectedPriceTaxAmount').textContent = `$${taxAmount}`;
        //            document.getElementById('selectedPriceInsuranceAmount').textContent = `$${insuranceAmount}`;
        //            document.getElementById('selectedPriceTotalAmount').textContent = `$${totalAmount}`;
        //            //Insurance
        //        });
        //   // }
        //}
        async function loadCartPrices(cartId) {
            debugger
            const res = await fetch(`https://stageapi.kotina.com/apigateway/userList/GetMasterItems/GolfCartRates/GolfCartRates/${cartId}`);
            const data = await res.json();

            // 🔥 convert text → total hours
            function convertToHours(text) {
                const value = parseInt(text);

                if (text.includes("Hour")) return value;
                if (text.includes("Day")) return value * 24;
                if (text.includes("Week")) return value * 7 * 24;

                return 0;
            }

            // ✅ API data ko transform karo
            const prices = data.map((item, index) => ({
                price_id: index + 1,
                priceper_hours: parseFloat(item.value), // API value
                cart_id: cartId,
                hours: item.text,
                total_Hours: convertToHours(item.text)
            }));

            const dropdown = document.getElementById('priceDropdown');
            dropdown.innerHTML = '<option value="">-- Select --</option>';

            prices.forEach(price => {
                const option = document.createElement('option');
                option.value = price.total_Hours;
                option.textContent = price.hours;
                option.dataset.price = price.priceper_hours;
                dropdown.appendChild(option);
            });

            // 🔥 change event (same as your logic)
            dropdown.addEventListener('change', function () {

                const selected = dropdown.options[dropdown.selectedIndex];
                //console.log('selected', selected)

                const price = selected?.dataset?.price? parseFloat(selected.dataset.price).toFixed(2)
                    : '0.00';


                //console.log('selected?.dataset?.price', selected?.dataset?.price)

                //tax = 10;
                const taxAmount = selected?.dataset?.price
                    ? (parseFloat(price) * parseFloat(tax) / 100).toFixed(2)
                    : '0.00';
                //console.log('taxAmount', taxAmount, 'tax', tax)
               // insurance = 20;
                const insuranceAmount = selected?.dataset?.price
                    ? (parseFloat(price) * parseFloat(insurance) / 100).toFixed(2)
                    : '0.00';
                //console.log('insuranceAmount', insuranceAmount)
                const totalAmount = selected?.dataset?.price
                    ? (parseFloat(price) + parseFloat(taxAmount) + parseFloat(insuranceAmount)).toFixed(2)
                    : '0.00';

                //console.log('totalAmount', totalAmount)

                taxAmountTotal = taxAmount;
                insuranceAmountTotal = insuranceAmount;
                basePrice = price;
                NetTotal = totalAmount;

                document.getElementById('selectedPrice').textContent = `$${price}`;
                document.getElementById('selectedPriceTaxAmount').textContent = `$${taxAmount}`;
                document.getElementById('selectedPriceInsuranceAmount').textContent = `$${insuranceAmount}`;
                document.getElementById('selectedPriceTotalAmount').textContent = `$${totalAmount}`;
            });
        }

       
        
        window.bookCartFromAvailability = bookCartFromAvailability
        async  function bookCartFromAvailability(cartName, cartId, selectedDate, cartType, description) {
          debugger;

          const userId = "00000000-0000-0000-0000-000000000000";
          const ip = "0.0.0.0";
            //  NO 'let' here — assign directly to globals
             let  percentage = 0;
             let  Insurence = 0;
             let  addedAmount = 0;


            try {
              const response = await fetch(`https://stageapi.kotina.com/apigateway/GolfCart/GetGolfCartRentalDetailById/${cartId}/${userId}/${ip}`);

              const data = await response.json();
              const parsedResponse = JSON.parse(data.response);
              const assetDetail = JSON.parse(parsedResponse.assetDetail);

              const baseAssetPrice = parseFloat(assetDetail?.price) || 0; //  named clearly
              percentage = parseFloat(assetDetail?.rate_calculatedamount) || 0;
              Insurence = parseFloat(assetDetail?.insurance) || 0;

              //  Price is now defined
              if (assetDetail?.rate_calculatedType === "FixedAmount") {
                  addedAmount = percentage;
              } else if (assetDetail?.rate_calculatedType === "Percent") {
                  addedAmount = baseAssetPrice * (percentage / 100); //  fixed
              } else {
                  percentage = 12.5; //  sync global for loadCartPrices
                  addedAmount = baseAssetPrice * (12.5 / 100);
              }


          } catch (err) {
              console.error("API Error:", err);
          }

          // ✅ Now safe everywhere
            //console.log("percentage:", percentage);
            //console.log("Insurance:", Insurence);
            //console.log("Added Amount:", addedAmount);

              
            // Remove existing booking form
            const existingForm = document.getElementById("bookingFormContainer");
            if (existingForm) existingForm.remove();

            // Remove previous "Want to book" user messages added by availability clicks
            const chatMessages = document.getElementById("chatMessages");
            const userMessages = chatMessages.querySelectorAll(".message.user");
            userMessages.forEach(msg => {
                if (msg.textContent.startsWith("Want to book")) {
                    msg.closest(".message-container").remove();
                }
            });

            const cartObj = {
                name: cartName,
                cart_name: cartName,
                cart_id: cartId,
                id: cartId,
                cart_type: cartType,
                description: description,
                price: "",
                rental_type: "hourly",
                row_num: cartId,
                ImagePaths: [],
                 
                tax: percentage,      //  matches button.tax
                insurance: Insurence, //  matches button.insurance
                addedAmount: addedAmount
            };  

            bookCart(cartObj);

            setTimeout(() => {
                const pickupDate = document.getElementById("pickupDate");
                if (pickupDate) {
                    pickupDate.value = selectedDate;
                    pickupDate.dispatchEvent(new Event("change"));
                }
            }, 100);
        }

    }, 2000);





</script>


<style setup>

    /* Import Google font - Poppins */
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');


    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: "Poppins", sans-serif;
    }


    body {
        background-color: #f0f0f0;
        margin: 0;
        padding: 0;
        font-size: 15px;
        letter-spacing: 0.5px !important;
    }

    .chat-container {
        width: 30%;
        max-width: 800px;
        background-color: #6a6a6a;
        border-radius: 10px 10px 0px 0px;
        box-shadow: -13px 17px 7px 8px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        height: 70vh;
        position: fixed;
        bottom: 67px;
        right: 20px;
        transform: translateY(100%);
        transition: transform 0.3s ease;
        z-index: 1000;
        background-image: url("https://appfilemedia.talygen.com/Upload/UnifiedCommunication/b924ddd1-eb57-4b6a-b526-c3741726c174.png")
    }

        .chat-container.open {
            transform: translateY(0);
        }


    .markdown h1 {
        font-size: 2em;
        color: blue;
    }

    .markdown p {
        font-size: 1em;
        line-height: 1.5;
    }

    .chat-header {
        background-color: #e46726;
        color: white;
        padding: 8px;
        text-align: Left;
        border-radius: 10px 10px 0 0;
        position: relative;
        font-size: 20px;
    }

        .chat-header .toggle-button {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            background: none;
            border: none;
            color: white;
            font-size: 16px;
            cursor: pointer;
        }

    .chat-messages {
        flex: 1;
        padding: 20px 10px 10px;
        overflow-y: auto;
    }

    .chat-input {
        padding: 10px;
        border-top: 1px solid #ccc;
    }

        .chat-input input textarea {
            width: 530px;
            margin-left: 10px;
        }

        .chat-input select,
        .chat-input button {
            margin-left: 10px;
        }

        .chat-input input textarea,
        .chat-input select {
            border-radius: 20px;
            border: 1px solid #ccc;
            padding: 10px;
            font-size: 14px;
        }

        .chat-input button {
            background-color: #002bea;
            color: white;
            border: none;
            padding: 19px 29px;
            border-radius: 6px;
            cursor: pointer;
            position: absolute;
            right: 31px;
            bottom: 32px;
        }

            .chat-input button:disabled {
                background-color: #cccccc;
                cursor: not-allowed;
            }

        .chat-input textarea {
            height: 55px;
            width: 100%;
            border: none;
            outline: none;
            resize: none;
            max-height: 180px;
            padding: 15px 15px 15px 0;
            font-size: 0.95rem;
        }

            .chat-input textarea:valid ~ span {
                visibility: visible;
            }


        .chat-input span {
            align-self: flex-end;
            color: #e46726;
            cursor: pointer;
            height: 55px;
            display: flex;
            align-items: center;
            visibility: hidden;
            font-size: 1.35rem;
        }

    @font-face {
        font-family: 'Material Symbols Rounded';
        font-style: normal;
        font-weight: 400;
        src: url(https://fonts.gstatic.com/s/materialsymbolsrounded/v232/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDJ_vb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOc7TOVpeRL2w5rwZu2rIelXxc.woff2) format('woff2');
    }

    .material-symbols-rounded {
        font-family: 'Material Symbols Rounded';
        font-weight: normal;
        font-style: normal;
        font-size: 24px;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        word-wrap: normal;
        direction: ltr;
        -moz-font-feature-settings: 'liga';
        -moz-osx-font-smoothing: grayscale;
    }


    .chat-container .chat-input {
        display: flex;
        gap: 5px;
        position: absolute;
        bottom: -56px;
        width: 100%;
        background: #fff;
        padding: 0px 20px;
        border-top: 1px solid #ddd;
        border-radius: 0px 0px 10px 10px;
    }

    .message-container {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        font-size: 12px !important;
    }

    .bot-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
    }

    .message {
        max-width: 80%;
        padding: 10px;
        border-radius: 10px;
        word-wrap: break-word;
        width: 100%;
        color: #2b2b2b !important;
    }

        .message p {
            color: #2b2b2b !important;
        }

    .paymentBox-content {
        max-width: 100% !important;
    }

    .message.user {
        background-color: #e46726;
        margin-left: auto;
        text-align: left;
        padding-bottom: 8px;
        width: auto;
        color: #fff !important;
        font-size: 1.1em !important
    }

    .message.bot {
        background-color: #fff;
        margin-right: auto;
        text-align: left;
        /*box-shadow: 0px 0px 5px #c1c0c0;*/
        font-size: 13px !important
    }

    .chat-container .markdown-content a {
        color: #e46726 !important;
    }

    .typing-indicator {
        display: none;
        margin-bottom: 10px;
        margin-top: 10px;
        margin-left: 10px;
        position: absolute;
        bottom: -4px;
    }

    /* Dots animation */
    .dots {
        display: inline-block;
    }

        .dots span {
            display: inline-block;
            width: 8px;
            height: 8px;
            margin: 0 2px;
            background-color: #fff;
            border-radius: 50%;
            animation: bounce 0.6s infinite alternate;
        }

            .dots span:nth-child(2) {
                animation-delay: 0.2s;
            }

            .dots span:nth-child(3) {
                animation-delay: 0.4s;
            }

    @keyframes bounce {
        from {
            transform: translateY(0);
        }

        to {
            transform: translateY(-6px);
        }
    }




    .spinner {
        display: none;
        margin-bottom: 3px;
        margin-top: 0px;
        /* margin-left: 519px; */
        z-index: 1;
        right: 50px;
        position: absolute;
        /* right: 54px !important; */
        bottom: -44px;
    }

    .carousel img {
        width: 100%;
        height: 190px;
        object-fit: cover;
    }

    .chatbot-body {
        padding: 10px;
    }

    .property-details {
        margin-top: 15px;
    }

        .property-details h6 {
            font-size: 16px;
            font-weight: bold;
        }

        .property-details p {
            font-size: 14px;
            margin-bottom: 5px;
        }

    .price-tag {
        font-size: 18px;
        color: #28a745;
        font-weight: bold;
    }

    .btn-book {
        background-color: #e46726;
        color: white;
        margin-top: 10px;
        width: 100%;
        padding: 10px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        font-size: 16px;
    }

    .btn-clear {
        background-color: #dc3545;
        color: #fff;
        border: none;
        padding: 10px;
        width: 100%;
        border-radius: 5px;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    .btn-soldout {
        background-color: #dc3545;
        color: white;
        margin-top: 10px;
        width: 100%;
        padding: 10px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .chatbot-footer {
        padding: 10px;
        border-top: 1px solid #e9ecef;
    }

        .chatbot-footer input textarea {
            width: 75%;
            border: 1px solid #ced4da;
            border-radius: 5px;
            padding: 8px;
        }

        .chatbot-footer button {
            width: 20%;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 5px;
            padding: 8px;
            cursor: pointer;
        }

    body.chat-container .chatbot {
        opacity: 1;
        pointer-events: auto;
        transform: scale(1);
    }


    .multiline {
        overflow: auto;
        resize: vertical;
        width: 80%;
        box-sizing: border-box;
        min-height: 42px;
        float: left;
        border-radius: 10px;
        padding: 10px 5px;
    }

    .bookingforminput {
        border-radius: 4px;
        border: 1px solid #6f6f6f;
        min-width: 180px;
    }

    .bookingforminputreadonly {
        border-radius: 4px;
        border: 1px solid #6f6f6f;
        min-width: 238px;
        background-color: #f5e3d0;
    }

    .label_100 {
        min-width: 100px
    }

    #bookingForm {
        display: none;
        border: 1px solid #ccc;
        padding: 15px;
        max-width: 400px;
        background: white;
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 2px 2px 10px rgba(0,0,0,0.2);
        text-align: left;
    }

        #bookingForm label {
            display: block;
            font-weight: bold;
            margin-top: 10px;
        }

        #bookingForm input {
            width: 100%;
            padding: 8px;
            margin-top: 5px;
            margin-bottom: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
        }

    #confirmBookingBtn {
        background-color: #28a745;
        color: white;
        padding: 10px;
        border: none;
        cursor: pointer;
        width: 100%;
    }

        #confirmBookingBtn:hover {
            background-color: #218838;
        }

    /* Hotel Card Styling */
    .hotel-card {
        background: linear-gradient(135deg, #f4f4f4 0%, #f9f3d0 100%);
        border-radius: 10px;
        margin-bottom: 20px;
        padding: 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease, opacity 0.5s ease;
        opacity: 0;
    }

    .hotel-header h5 {
        margin: 0;
        color: #333;
        font-size: 20px;
    }

    .hotel-header p {
        margin: 4px 0;
        color: #666;
        font-size: 12px;
    }

    .hotel-location, .hotel-amenities {
        font-style: italic;
    }

    /* Carousel Customization */
    /* .carousel {
    margin-top: 15px;
    } */

    .carousel-inner {
        border-radius: 10px;
        overflow: hidden;
    }

    .carousel-item {
        text-align: center;
        padding: 15px 0px;
    }

    .room-info h6 {
        margin: 10px 0 5px;
        color: #333;
    }

    .room-info .availability,
    .room-info .price {
        margin: 5px 0;
        font-weight: 500;
    }

    .room-images {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        margin: 10px 0;
    }



    /* Book Now Button */
    .btn-book {
        background-color: #e46726;
        color: #fff;
        border: none;
        padding: 10px;
        width: 100%;
        border-radius: 5px;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

        .btn-book:hover {
            background-color: #1a1a1a;
        }

    /* Additional Chat Layout Styles */
    .message-container {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
    }

    .bot-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
    }



    .mainbasediv {
        width: 100%;
    }

    /* Carousel control button overrides for better visibility */
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 50%;
        padding: 8px;
    }

    .carousel-image {
        width: auto;
        height: auto;
        max-width: 100%;
        object-fit: cover;
        border-radius: 5px;
    }

    /* Carousel control button overrides for better visibility */
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 50%;
        padding: 8px;
    }

    /* Booking Card Container */
    .booking-card {
        max-width: 400px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        font-family: Arial, sans-serif;
        padding: 0px !important;
        margin-bottom: 10px !important;
    }


    .booking-card-header {
        background: #e46726;
        padding: 15px;
        color: white;
        text-align: center;
    }

        .booking-card-header h3 {
            margin: 0 0 5px;
            font-size: 20px;
            color: #fff;
        }

        .booking-card-header p {
            margin: 0;
            font-size: 14px;
            color: #fff !important;
        }

    /* Hidden Inputs */
    .hidden-inputs {
        display: none;
    }

    /* Body */
    .booking-card-body {
        padding: 15px;
    }

    .form-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        color: #1a1a1a;
        width: 100%;
    }

        .form-row.price {
            display: flex;
        }

    .chat-container label {
        font-weight: bold;
        display: block;
        flex: 1;
    }

    .chat-container select, input {
        width: 55%;
        padding: 6px;
        border: 1px solid #ccc;
        border-radius: 4px;
        text-align: left;
    }

    .note {
        font-size: 12px;
        color: #777;
    }

    .booking-card-footer {
        padding: 15px;
        text-align: center;
    }

    #confirmBookingBtn {
        background: #28a745;
        color: white;
        padding: 10px 15px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        font-size: 16px;
    }

        #confirmBookingBtn:hover {
            background: #218838;
        }

    /***** Booking Confirmation Card *****/
    .booking-confirmation-card {
        background: #fff;
        border-radius: 10px;
        padding: 15px 20px;
        max-width: 500px;
        margin: 10px 0;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        color: #333;
    }

    /* Header Section */
    .confirmation-header {
        text-align: center;
        margin-bottom: 15px;
    }

        .confirmation-header h3 {
            margin: 0;
            font-size: 18px;
            color: #007bff;
        }

        .confirmation-header p {
            margin: 5px 0 0;
            font-size: 14px;
            color: #555;
        }

    /* Body Section */
    .confirmation-body {
        margin-bottom: 15px;
    }

    .detail-line {
        margin: 8px 0;
        font-size: 14px;
        line-height: 1.4;
    }

        .detail-line .label {
            font-weight: 600;
            margin-right: 5px;
            color: #444;
        }

        .detail-line .value {
            color: #555;
        }

    /* Footer Section */
    .confirmation-footer {
        text-align: center;
        border-top: 1px solid #f0f0f0;
        padding-top: 10px;
    }

        .confirmation-footer p {
            margin: 0;
            font-size: 14px;
            color: #666;
        }


    .hidden-text {
        color: #e1f5fe;
        font-size: 1px;
        display: none;
    }

    /***** Menu design *****/

    .menu-container {
        background: #fff;
        padding: 15px;
        border-radius: 8px;
        box-shadow: 2px 2px 8px rgba(0,0,0,0.1);
        text-align: center;
    }

    .menu-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
    }

    .menu-item {
        border: 1px solid #ddd;
        padding: 15px;
        background: #f9f9f9;
        width: 220px;
        border-radius: 8px;
        text-align: center;
    }

    .menu-img {
        width: 100%;
        height: 120px;
        object-fit: cover;
        border-radius: 5px;
    }

    .available {
        color: green;
        font-weight: bold;
    }

    .unavailable {
        color: red;
        font-weight: bold;
    }

    .hotel-list-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 15px;
        background: #fff; /* Ensure visibility */
        border-radius: 10px;
    }

    .hotel-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 14px;
        background: #f9f9f9; /* Light background */
        border: 1px solid #ddd; /* Border for clarity */
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: 0.2s ease-in-out;
    }

        .hotel-item:hover {
            background: #e3f2fd; /* Light blue hover effect */
            transform: scale(1.02);
        }

    .hotel-title {
        font-size: 16px;
        font-weight: bold;
        color: #333; /* Ensure text is visible */
    }


    .typing-dots {
        display: inline-flex;
        font-size: 18px;
        letter-spacing: 2px;
    }

        .typing-dots span {
            animation: typingBlink 1.4s infinite;
            margin-right: 3px;
        }

            .typing-dots span:nth-child(2) {
                animation-delay: 0.2s;
            }

            .typing-dots span:nth-child(3) {
                animation-delay: 0.4s;
            }

    @keyframes typingBlink {
        0% {
            opacity: 0.2;
        }

        20% {
            opacity: 1;
        }

        100% {
            opacity: 0.2;
        }
    }






    #toast {
        visibility: hidden;
        min-width: 250px;
        margin-left: -125px;
        background-color: #333;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        padding: 16px;
        position: fixed;
        z-index: 1;
        left: 50%;
        bottom: 50%;
        font-size: 17px;
        margin-right: 184px;
    }

        #toast.show {
            visibility: visible;
            animation: fadein 0.5s;
        }

    .toast-message {
        display: inline-block;
    }

    .close-btn {
        position: absolute;
        right: 10px;
        top: 5px;
        cursor: pointer;
        color: #fff;
        font-size: 18px;
    }

    @keyframes fadein {
        from {
            bottom: 0;
            opacity: 0;
        }

        to {
            bottom: 30px;
            opacity: 1;
        }
    }
    /* Body Section */
    #overlay {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 999;
    }

    .cart-container h3 {
        /*padding: 10px;*/
        color: #2b2b2b !important;

    }

    .cart-sections {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        
    }

    .cart-card {
        background: #fff;
        /* border: 1px solid #ddd; */
        /* border-radius: 10px; */
        /* padding: 15px; */
        width: 500px;
        /* box-shadow: 0 2px 5px rgb(0 0 0 / 14%); */
        color: #1a1a1a;
        /* border-bottom: 1px solid #000; */
        padding-bottom: 20px;
    }

        .cart-card h4 {
            margin-top: 0;
            font-size: 22px;
            padding-bottom: 10px;
        }

    .btn-book {
        margin-top: 10px;
        background: #e46726;
        color: white;
        padding: 6px 12px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
    }

    .cart-images {
        display: flex;
        gap: 6px;
        margin: 8px 0;
        flex-wrap: wrap;
    }

    .cart-img {
        width: 80px;
        height: 60px;
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid #ccc;
    }

    .carousel {
        overflow: hidden;
        width: 100%;
        max-width: 600px;
        margin: auto;
    }

    .carousel-track {
        display: flex;
        transition: transform 0.3s ease-in-out;
    }

    .carousel-slide {
        min-width: 100%;
        box-sizing: border-box;
        padding: 10px;
    }

        .carousel-slide img {
            width: 100%;
            border-radius: 12px;
        }

    .chat-messages .iframe-content {
        width: 100% !important;
        height: 900px !important;
    }

    .check-box {
        display: flex;
    }

        .check-box input {
            width: auto;
        }

        .check-box label {
            margin-left: 10px !important;
        }

    .chat-messages .iframe-content .paymentBox-content {
        max-width: 100% !important
    }

    .delivery-loc strong {
        width: 55%;
    }

    .chat-bot-icon {
        background: #e46726;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 26px;
        z-index: 99;
        right: 97px;
        -webkit-animation: shimmy 2s infinite;
        animation: shimmy 2s infinite;
        -webkit-animation-direction: alternate;
        animation-direction: alternate;
    }

    @keyframes shimmy {
        0% {
            -webkit-transform: translate(0, 0);
            transform: translate(0, 0);
        }

        100% {
            -webkit-transform: translate(0, 20px);
            transform: translate(0, 20px);
        }
    }


    .bot-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }

    .chat-container strong {
        font-weight: 700;
        color: #e46726;
    }

    @media (max-width:767px) {
        .chat-container {
            width: 90% !important;
            right: 18px
        }

        .chat-bot-icon {
            bottom: 35px !important;
            right: 20px !important;
        }
    }

    .wel-come {
        font-size: 1.2em !important;
    }

    .input-error {
        border: 1px solid red !important;
    }

    .error-msg {
        color: red;
        font-size: 11px;
        padding-bottom: 10px;
        width: 50%;
        float: right;
        width: 55%;
    }
</style>